import React, { useState, useEffect } from 'react'
import { connect } from "react-redux";
import { formValues, setTabHideValues } from "../../redux/actions/action";
import { OnChange } from "react-final-form-listeners";
import axios from 'axios';
import {useGlobalSpinnerActionsContext} from '../../context/GlobalSpinnerContext'
import _ from 'lodash';
import OUMapping from '../../assets/data/registerOU'
import {facilityMapping} from '../../assets/data/facilityOU'
import {DropzoneArea} from 'material-ui-dropzone'
import {DropzoneDialog} from 'material-ui-dropzone'


import HideShowCondition from "../validation/HideShowCondition";

import AssignCondition from "../validation/Assign";

import Validator from '../validation/validator/validatorStage'
import { HideCheckboxOptions } from '../../assets/data/hideCheckboxOnCondition'
import ShowError from "../validation/showError/ShowError";
import OfflineDb from '../../db'
// import HideStageFieldsOptions from '../validation/hideOptions/HideStageFieldsOptions'
import OUFieldConfig from './OUStageFieldConfig';
import DisplayText from "../validation/DisplayText.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode, faTimes, faFileUpload } from "@fortawesome/free-solid-svg-icons";
import QrReader from 'react-qr-reader'
import ReferalForm from "../forms/referalForm/ReferalForm";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { isEmpty, isString } from "../../helper/index";
import {
    Button,
    ButtonStrip,
    InputFieldFF,
    SingleSelectFieldFF,
    ReactFinalForm,
    SwitchFieldFF,
    hasValue,
    TextAreaFieldFF,
    composeValidators,
    dhis2Username,
    FieldGroupFF,
    CheckboxFieldFF,
    MultiSelectFieldFF,
    FileInput,
    FileInputFieldFF
} from "@dhis2/ui";

import {
    TextField,
    Checkboxes,
    CheckboxData,
    Radios,
    Select,
    TimePicker,
    Switches,
    KeyboardDatePicker,
    DatePicker,
    DateTimePicker,
    Autocomplete,
} from "mui-rff";


//   import { Select } from 'mui-rff';
import { MenuItem } from "@material-ui/core";

import Grid from "@material-ui/core/Grid";

import { Checkbox as MuiCheckbox } from "@material-ui/core";

//   import {Checkboxes, CheckboxData} from 'mui-rff';

import "date-fns";
import DateFnsUtils from "@date-io/date-fns";

import { apiServices } from "../../services/apiServices";
import {useTranslation} from 'react-i18next';
import { Configuration } from '../../assets/data/config';
import { parse, parseJSON } from 'date-fns';
import { el, is, tr } from 'date-fns/locale';
const { Form, Field } = ReactFinalForm;

const ValidatorComponent = (
    fieldId,
    attribute,
    values,
    form,
    rules,
    field,
) => {
    let programRules = rules.programRule;
    let programRulesVariables = rules.programRuleVariable;

    let filteringRuleWithField = null;
    let Flag = null;
    let val = null;
    let conditionArray = [];
    let programRuleActionType = null;
    let hideShow = true
    let assign
    programRules.map((rules) => {
        filteringRuleWithField = rules.programRuleActions.filter((obj) =>
            obj.dataElement ? fieldId == obj.dataElement.id : undefined
        );

        if (filteringRuleWithField.length > 0) {
            switch (filteringRuleWithField[0].programRuleActionType) {
                case "HIDEFIELD":
                    hideShow = HideShowCondition(
                        rules,
                        programRulesVariables,
                        values,
                        field,
                        fieldId
                    );
                    break;

                case "ASSIGN":
                    assign =
                        AssignCondition(
                            rules,
                            programRulesVariables,
                            values,
                            field,
                            fieldId,
                            attribute,
                            filteringRuleWithField

                        );
                    break;

                // case 'DISPLAYTEXT':
                //
                //     programRuleActionType = DisplayText(rules, programRulesVariables, values, field, fieldId)
                // break;

                // case "SHOWERROR":
                //   programRuleActionType = ShowError(
                //     rules,
                //     programRulesVariables,
                //     values,
                //     field,
                //     fieldId,
                //     attribute
                //   );
                //   break;

                // case 'HIDEOPTION':
                //     programRuleActionType = HideStageFieldsOptions(rules, programRulesVariables, values, field, fieldId, attribute)
                // break;
            }
        }
    });
    return ({
        'hideShow': hideShow,
        'assign': assign
    })
};
const getTranslatedLabels = (dataElement) => {
    if (localStorage.getItem("locale") == "en") {
        return dataElement.displayName;
    } else if (dataElement.translations && dataElement.translations.length > 0) {
        let label = dataElement.translations.filter(
            (tanslation) =>
                tanslation.property == "NAME" &&
                tanslation.locale == localStorage.getItem("locale")
        );
        if (label.length > 0) {
            return label[0].value;
        } else {
            return dataElement.displayName;
        }
    }
    return dataElement.displayName;
};

function InputFieldConfig(props) {
    let fieldData = props.fieldData
    let customIsDisable = props.customIsDisable
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup
    let stagesDataExist = props.stagesData ? props.stagesData.length > 0 ? true : false : false;
    let newServiceData = props.newServiceData
    let customfieldobj = props.customfieldobj;
    const {t} = useTranslation()
    const [fieldType, setFieldType] = useState(null)
    const [optionSet, setOptions] = useState(null)
    const [icons, setIcons] = useState(null)
    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)
    const [sessionUserBoValue, setSessionUserBoValue] = useState(null)
    let OUJSON = props.OUJSON.organisationUnits
    let orgid = props.programorgid
    
    const required = value => (fieldData.compulsory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)
    const scriptCheck = value => (value ? value.match(/<[^>]*>/g) != null ? t('Incorrect expression "< or >" added as input') : undefined : undefined)
    const requiredOptions = value => (fieldData.compulsory && validationResult.hideShow == true ? value ? undefined : t('Please fill out this field') : undefined)
    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    function checkHideOptionsFields(attributes, programRules, programRulesVariables, values) {
        const fieldId = attributes.dataElement.id;
        let option = [];
        let filteringRuleWithField = null;

        programRules.map((rules) => {
            filteringRuleWithField = rules.programRuleActions.filter((obj) =>
                obj.dataElement ? fieldId == obj.dataElement.id : undefined
            );

            if (
                filteringRuleWithField.length > 0 &&
                filteringRuleWithField[0].programRuleActionType == "HIDEOPTION"
            ) {
                const operators = ["==", "!="];
                const condition = rules.condition;
                const splitConditions = condition.split("&&");
                let Flag = null;
                let val = null;
                let conditionArray = [];
                splitConditions.map((splitCondition) => {
                    const variableName = splitCondition.match(/\{(.*?)\}/)[1];
                    const parentRaw = programRulesVariables.filter(
                        (obj) => obj.displayName == splitCondition.match(/\{(.*?)\}/)[1]
                    ); //[0] .dataElement.id
                    const parentNameFromFilter =
                        parentRaw.length > 0 ? parentRaw[0].displayName : undefined;
                    const parentId =
                        parentRaw.length > 0
                            ? parentRaw[0].dataElement
                                ? parentRaw[0].dataElement.id
                                : parentRaw[0].trackedEntityAttribute
                                    ? parentRaw[0].trackedEntityAttribute.id
                                    : undefined
                            : undefined;

                    const parentNameFromFilterStart = splitCondition.search(
                        parentNameFromFilter
                    );
                    const parentNameLength = parentNameFromFilter
                        ? parentNameFromFilter.length
                        : undefined;

                    const operatorInitLength =
                        parentNameFromFilterStart + parentNameLength + 2;

                    const operator = splitCondition.substring(
                        operatorInitLength,
                        operatorInitLength + 2
                    );

                    const alternateOperatorFinding = operators.map((ops) => {
                        if (splitCondition.search(ops) > -1) {
                            const a = {
                                operator: ops,
                                operatorLength: splitCondition.search(ops),
                            };
                            return a;
                        }
                    });
                    const stringLength = splitCondition.length;
                    if (parentNameFromFilter) {
                        const filteredOperator = alternateOperatorFinding.filter(
                            (obj) => obj != undefined
                        );

                        const conditionValueRaw =
                            filteredOperator.length > 0
                                ? splitCondition.substring(
                                    filteredOperator[0].operatorLength + 3,
                                    splitCondition.length
                                )
                                : undefined;

                        const removeEmptySpace =
                            conditionValueRaw != undefined
                                ? conditionValueRaw.substring(
                                    conditionValueRaw.length - 1,
                                    conditionValueRaw.length
                                ) == " "
                                    ? conditionValueRaw.substring(0, conditionValueRaw.length - 1)
                                    : conditionValueRaw
                                : undefined;

                        const conditionValue =
                            removeEmptySpace != undefined
                                ? removeEmptySpace.substring(1, removeEmptySpace.length - 1)
                                : undefined;
                        const conditionalOperator =
                            filteredOperator.length > 0
                                ? filteredOperator[0].operator
                                : undefined;
                        let conditionForValidation = null;
                        if (conditionalOperator != undefined) {
                            val = conditionValue;
                            switch (conditionalOperator) {
                                case "==":
                                    if (
                                        values[parentId] != undefined &&
                                        String(values[parentId]) == String(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.dataElement.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        if (option.length > 0) {
                                                            let checkOptionInArray = option.find(obj => obj.id == options.id)
                                                            if(checkOptionInArray == undefined) {
                                                                option.push(options);
                                                            }
                                                    
                                                        } else {
                                                            option.push(options);
                                                        }
                                                        
                                                        
                                                        
                                                    } else {
                                                        // values[fieldId] = ''
                                                    
                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                    
                                                        let checkOptionInArray = option.find(obj => obj.id == temp.id)
                                                    
                                                        if(checkOptionInArray == undefined) {
                                                            option.push(temp);
                                                        }
                                                        
                                                        
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case ">=":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) >= Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.dataElement.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case "<=":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) <= Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.dataElement.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case "<":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) < Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.dataElement.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;

                                case ">":
                                    if (
                                        values[parentId] != undefined &&
                                        Number(values[parentId]) > Number(conditionValue)
                                    ) {
                                        // values[fieldId] = ''

                                        filteringRuleWithField.map((optionHideRule) => {
                                            attributes.dataElement.optionSet.options.map(
                                                (options) => {
                                                    if (options.id != optionHideRule.option.id) {
                                                        option.push(options);
                                                    } else {
                                                        // values[fieldId] = ''

                                                        var temp = {
                                                            id: options.id,
                                                            code: options.code,
                                                            displayName: null,
                                                        };
                                                        option.push(temp);
                                                    }
                                                }
                                            );
                                        });
                                    } else {
                                        // values[fieldId] = ''
                                    }
                                    break;
                            }
                        } else {
                            // values[parentId] != ''
                            // values[fieldId] = ''
                        }
                    }
                });
            }
        });
        
        if (option.length > 0) {
            return option;
        } else {
            return attributes.dataElement.optionSet.options
        }
    }

    function findFieldType() {
        const dataElement = fieldData.dataElement
        if (dataElement.optionSet != undefined) {
            if (fieldData.renderOptionsAsRadio) {
                setFieldType('radio')
            } else {
                if (fieldData.renderType) {
                    if (fieldData.renderType.DESKTOP) {
                        if (fieldData.renderType.DESKTOP.type == "ICONS_AS_BUTTONS") {
                            setFieldType('radio')
                        } else {
                            setFieldType('dropdown')
                        }
                    }
                }
            }
        } else {
            setFieldType('text')
        }
        
    }

    function fetchOption() {
        let output = []
        const dataElement = fieldData.dataElement
        
        if (dataElement.optionSet != undefined) {
            let refinedOptionList = checkHideOptionsFields(fieldData, programRules, programRulesVariables, values);
            
            //dataElement.optionSet.options.map((items, index) => {
            refinedOptionList.map((items, index) => {    
                if (icons.length > 0) {
                    output.push({ 'value': items.code, 'label': <> <span dangerouslySetInnerHTML={{ __html: icons[index] }} /> <>{getTranslatedLabels(items)} </>  </> })
                } else {
                    output.push({ 'value': items.code, 'label': getTranslatedLabels(items) })
                }
            })

        }
        if (output.length > 0) {
            setOptions(output)
        }
    }

    function getIcons() {
        let promises = [];
        const dataElement = fieldData.dataElement
        if(navigator.onLine){
            if (dataElement.optionSet != undefined) {
                dataElement.optionSet.options.forEach((options) => {
                    if (options.style != undefined) {
    
                        const getIconApi = 'icons/' + options.style.icon + '/icon.svg'
                        promises.push(apiServices.getAPI(getIconApi))
                    } else {
                        promises.push({})
                    }
                })
    
                Promise.all(promises).then((responses) => {
    
                    const icons = responses.map((response) => response.data)
    
                    if (icons.length > 0) {
                        setIcons(icons)
                    } else {
                        setIcons([])
                    }
                })
            } else {
                setIcons([])
            }
        }else{
            setIcons([])
        }
        

    }

    function fetchValidation() {
        
        if(fieldData.dataElement.id == "pGm3J84yrAb") { //htc referral location
            if(values['pGm3J84yrAb'] == "Yes" && !values['Tb1FK3EmJv9']) {
                values['Tb1FK3EmJv9'] = false
            }

        }
        if(fieldData.dataElement.id == "tDodu9Pv0q2") { //sti referral location
            if(values['tDodu9Pv0q2'] == "Yes" && !values['zlysYK15mXq']) {
                values['zlysYK15mXq'] = false
            }

        }
        if(fieldData.dataElement.displayName == "Determine"){
            //console.log('Determine>>>', defaultValue,values) HTC services
            if(values["HBXuLtCgRHs"] == "Accompanied Referral" || values["HBXuLtCgRHs"] == "Referral"){
              values[fieldData.dataElement.id] = '';
            }
          }

        //t94TTOWs3QI -tested in last 6months
        if(fieldData.dataElement.id == "t94TTOWs3QI") { //tested in last 6months
            if(!values['t94TTOWs3QI']) {
                values['t94TTOWs3QI'] = ''
            }
            if(values['t94TTOWs3QI'] && values['t94TTOWs3QI'] == "NO" && !values["HBXuLtCgRHs"]){
                // if(values['T2w3pT8DFeC']){ //T2w3pT8DFeC - is prep tavailable
                //     delete values['T2w3pT8DFeC'];
                // }
                if(values['fbbEnmGrs7a']){ //fbbEnmGrs7a - prep referral service
                    delete values['fbbEnmGrs7a'];
                }//fbbEnmGrs7a
            }

        }

        if(fieldData.dataElement.id == "OEJhAj3i1yX") { //ever tested
            if(values['OEJhAj3i1yX'] && values['OEJhAj3i1yX'] == "NO") {
                if(values['ydFtqaCs0IV']){
                    delete values['ydFtqaCs0IV']; //client status
                }
                if(values['t94TTOWs3QI']){
                    delete values['t94TTOWs3QI'];
                }
                if(values['svTN057036v'] && (!values["tgft2rEpVts"] || (values["tgft2rEpVts"] && values["tgft2rEpVts"] != 'Yes'))){ //ART referral service
                    delete values['svTN057036v'];
                }
                if(values['rubrYJZ78Ds'] && (!values["tgft2rEpVts"] || (values["tgft2rEpVts"] && values["tgft2rEpVts"] != 'Yes'))){ //ART referral Center
                    delete values['rubrYJZ78Ds'];
                }
            }else if(values[customfieldobj.HTCEverTested] && values[customfieldobj.HTCEverTested] == "YES" && (!values[customfieldobj.HTStestedinlast6months] || (values[customfieldobj.HTStestedinlast6months] && values[customfieldobj.HTStestedinlast6months] == "YES"))) {
                // if(values['HBXuLtCgRHs']){ //remove htc service
                //     delete values['HBXuLtCgRHs'];
                // }
                // if(values['UcPCwWPERO1']){ //onsite
                //     delete values['UcPCwWPERO1'];
                // }
                // if(values['qnaAvZPwh42']){ //testing
                //     delete values['qnaAvZPwh42'];
                // }
                /*if(values['T2w3pT8DFeC']){ //T2w3pT8DFeC - is prep tavailable
                    delete values['T2w3pT8DFeC'];
                }
                if(values['fbbEnmGrs7a']){ //T2w3pT8DFeC - HTC referral Services
                    delete values['fbbEnmGrs7a'];
                }*/

                // if(values['yzVBu2VffD3']){ //yzVBu2VffD3 - Mobile testing referral
                //     delete values['yzVBu2VffD3'];
                // }

                // if(values['ZHoqyBa59km']){ //HTC center
                //     delete values['ZHoqyBa59km'];
                // }
            }

        }

        if(fieldData.dataElement.id == "pGm3J84yrAb") { //do you want to receive service
            if(!values['pGm3J84yrAb'] || (values['pGm3J84yrAb'] && values['pGm3J84yrAb'] == "No")) {
                if(values['HBXuLtCgRHs']){
                    delete values['HBXuLtCgRHs'];
                }
                if(values['t94TTOWs3QI']){
                    delete values['t94TTOWs3QI'];
                }
                if(values['ydFtqaCs0IV']){
                    delete values['ydFtqaCs0IV'];
                }
                if(values['u30iHcjgaz6']){ //on art
                    delete values['u30iHcjgaz6'];
                }
                if(values['svTN057036v']){ //art referral
                    delete values['svTN057036v'];
                }
                if(values['OEJhAj3i1yX']){ //ever tested
                    delete values['OEJhAj3i1yX'];
                }
                if(values['T2w3pT8DFeC']){ //T2w3pT8DFeC - is prep tavailable
                    delete values['T2w3pT8DFeC'];
                }

                if(values['fbbEnmGrs7a']){ //T2w3pT8DFeC - HTC referral Services
                    delete values['fbbEnmGrs7a'];
                }

                if(values['yzVBu2VffD3']){ //yzVBu2VffD3 - Mobile testing referral
                    delete values['yzVBu2VffD3'];
                }

                if(values['ZHoqyBa59km']){ //HTC center
                    delete values['ZHoqyBa59km'];
                }
            }

        }

        //client status - 
        if(fieldData.dataElement.id == "ydFtqaCs0IV") {
            if(!values['ydFtqaCs0IV'] || (values['ydFtqaCs0IV'] && (values['ydFtqaCs0IV'] == "Unknown" || values['ydFtqaCs0IV'] == "Negative"))) {
                if(values['u30iHcjgaz6'] && (!values["tgft2rEpVts"] || (values["tgft2rEpVts"] && values["tgft2rEpVts"] != 'Yes'))){ //on art u30iHcjgaz6
                    delete values['u30iHcjgaz6'];
                }
                if(values['svTN057036v'] && (!values["tgft2rEpVts"] || (values["tgft2rEpVts"] && values["tgft2rEpVts"] != 'Yes'))){ //ART referral service
                    delete values['svTN057036v'];
                }
                if(values['rubrYJZ78Ds'] && (!values["tgft2rEpVts"] || (values["tgft2rEpVts"] && values["tgft2rEpVts"] != 'Yes'))){ //ART referral Center
                    delete values['rubrYJZ78Ds'];
                }
            }else if((values['ydFtqaCs0IV'] && values['ydFtqaCs0IV'] == "Positive")) {
                if(values['t94TTOWs3QI']){ //tested in last 6months
                    delete values['t94TTOWs3QI'];
                }
                if(values['HBXuLtCgRHs']){ //remove htc service
                    delete values['HBXuLtCgRHs'];
                }
                if(values['qnaAvZPwh42']){ //remove htc service
                    delete values['qnaAvZPwh42'];
                }
            }
        }

        //htc service
        if(fieldData.dataElement.id == "HBXuLtCgRHs") {
            if(!values['HBXuLtCgRHs'] || (values['HBXuLtCgRHs'] && values['HBXuLtCgRHs'] != 'Onsite')){
                if(values['UcPCwWPERO1']){ //onsite
                    delete values['UcPCwWPERO1'];
                }
                if(values['qnaAvZPwh42']){ //testing
                    delete values['qnaAvZPwh42'];
                }
                if(!values['t94TTOWs3QI'] || (values['HBXuLtCgRHs'] && values['HBXuLtCgRHs'] != 'Onsite')){
                    if(values['T2w3pT8DFeC']){ //Is PrEP available?
                        delete values['T2w3pT8DFeC'];
                    }

                    if(values['fbbEnmGrs7a']){ //HTC referral Services
                        delete values['fbbEnmGrs7a'];
                    }
                }
            }

            if(values['HBXuLtCgRHs'] && values['HBXuLtCgRHs'] == 'Deferred'){
                if(values['yzVBu2VffD3']){ //yzVBu2VffD3 - Mobile testing referral
                    delete values['yzVBu2VffD3'];
                }
    
                if(values['ZHoqyBa59km']){ //HTC center
                    delete values['ZHoqyBa59km'];
                }
            }
            
        }
        //reset HTC referral Services to hide HTC referral Services , PrEP referral on testing selection
        if(fieldData.dataElement.id == "qnaAvZPwh42") {
            if(values['fbbEnmGrs7a'] && values['qnaAvZPwh42'] && (values['qnaAvZPwh42'] == 'Invalid' || values['qnaAvZPwh42'] == 'Positive')){
                if(values['T2w3pT8DFeC']){ //T2w3pT8DFeC - is prep tavailable
                    delete values['T2w3pT8DFeC'];
                }

                if(values['fbbEnmGrs7a']){ //T2w3pT8DFeC - HTC referral Services
                    delete values['fbbEnmGrs7a'];
                }
            }else if(values['qnaAvZPwh42'] && values['qnaAvZPwh42'] == 'Negative'){
                if(values['yzVBu2VffD3']){ //yzVBu2VffD3 - Mobile testing referral
                    delete values['yzVBu2VffD3'];
                }

                if(values['ZHoqyBa59km']){ //HTC center
                    delete values['ZHoqyBa59km'];
                }
            }
        }

        //on art
        if(fieldData.dataElement.id == "u30iHcjgaz6") {
            if(values['u30iHcjgaz6'] && values['u30iHcjgaz6'] == 'YES'){
                if(values['svTN057036v']){ //ART referral service
                    delete values['svTN057036v'];
                }
                if(values['rubrYJZ78Ds']){ //ART referral Center
                    delete values['rubrYJZ78Ds'];
                }
            }

        }

        //T2w3pT8DFeC - Is PrEP available?
        if(fieldData.dataElement.id == "T2w3pT8DFeC") {
            if(values['T2w3pT8DFeC'] && values['T2w3pT8DFeC'] == 'No'){
                if(values['fbbEnmGrs7a']){ //PrEP referral Services
                    delete values['fbbEnmGrs7a'];
                }
                if(values['Du1mvHcJlA5']){ //prep referral
                    delete values['Du1mvHcJlA5'];
                }
            }
        }

        //STI services- client symp no -- j67UThIlCra
        if(fieldData.dataElement.id == "j67UThIlCra") {
            if(values['j67UThIlCra'] && values['j67UThIlCra'] == 'No'){
                if(values['W2GQ7PJIHHh']){ //STI services
                    delete values['W2GQ7PJIHHh'];
                }
                if(values['ppnkyJJlASL']){ //STI center
                    delete values['ppnkyJJlASL'];
                }
                
            }
        }

        //STI services-  do you want to recieve tDodu9Pv0q2
        if(fieldData.dataElement.id == "tDodu9Pv0q2") {
            if(values['tDodu9Pv0q2'] && values['tDodu9Pv0q2'] == 'No'){
                if(values['W2GQ7PJIHHh']){ //STI services
                    delete values['W2GQ7PJIHHh'];
                }
                if(values['ppnkyJJlASL']){ //STI center
                    delete values['ppnkyJJlASL'];
                }
                if(values['j67UThIlCra']){ //client sym
                    delete values['j67UThIlCra'];
                }
                if(values['Rlz3O6wOpQq']){ //hea,th edu sym
                    delete values['Rlz3O6wOpQq'];
                }
            }
        }

        //tb services- client symp no -- bv11jsHSLZN
        if(fieldData.dataElement.id == "bv11jsHSLZN") {
            if(values['bv11jsHSLZN'] && values['bv11jsHSLZN'] == 'No'){
                if(values['bHc1NH28nW2']){ //tb services
                    delete values['bHc1NH28nW2'];
                }
                if(values['JsObII1YufJ']){ //tb center
                    delete values['JsObII1YufJ'];
                }
            }
        }

        //tb services-  do you want to recieve H7vi6um0FMY
        if(fieldData.dataElement.id == "H7vi6um0FMY") {
            if(values['H7vi6um0FMY'] && values['H7vi6um0FMY'] == 'No'){
                if(values['bHc1NH28nW2']){ //tb services
                    delete values['bHc1NH28nW2'];
                }
                if(values['JsObII1YufJ']){ //tb center
                    delete values['JsObII1YufJ'];
                }
                if(values['bv11jsHSLZN']){ //client sym
                    delete values['bv11jsHSLZN'];
                }
                if(values['J2F7vZvxzao']){ //hea,th edu sym
                    delete values['J2F7vZvxzao'];
                }
            }
        }

        //test result stage validation started
        let determineTest = "HhQNLlyPilm", determineType = "TiIi5COjvdU", uniGold = "IfgPLHu0Pf3", hivStatus = "tgft2rEpVts";
        let artReferral = "mnb6wbjMavs", artCenter = "LEP6NIPQ0pZ", statpak = "EmKOoPr5JGU", prepAvailable = "a7mQX6JvnqU", prepReferral = "LgNOYC5qWkZ",prepcenter = "oOaqOaQdzJ7";
        if(fieldData.dataElement.id == determineTest) { //determine
            if(values[determineTest] && values[determineTest] == "Determine Non- reactive Result"){
                //delete values[determineType]; //determine type
                delete values[uniGold]; //uni gold
                delete values[hivStatus]; //hivStatus
                delete values[artReferral]; //artReferral
                delete values[artCenter]; //artCenter
                delete values[statpak]; //statpak
            }else if(values[determineTest] && values[determineTest] == "Determine Invalid Result"){
                /*delete values[prepAvailable];
                delete values[prepReferral];
                delete values[prepcenter];*/
                //delete values[determineType]; //determine type
                delete values[uniGold]; //uni gold
                delete values[hivStatus]; //hivStatus
                delete values[artReferral]; //artReferral
                delete values[artCenter]; //artCenter
                delete values[statpak]; //statpak
            }else{
                if(values[determineTest] && values[determineTest] == "Determine Reactive Result"){
                    if(!values[uniGold] && !values[statpak]){
                        delete values[prepAvailable];
                        delete values[prepReferral];
                        delete values[prepcenter];
                    }
                }
                /*if(!values[determineType]){
                    delete values[prepAvailable];
                    delete values[prepReferral];
                    delete values[prepcenter];
                }*/
            }
        }

        /*if(fieldData.dataElement.id == determineType) { //determineType
            if(values[determineType]){
                if(values[determineType] == "Stat-pak reactive" || values[determineType] == "Uni-gold Reactive"){
                    delete values[prepAvailable];
                }
                if(values[determineType] && values[determineType] == "Stat-pak"){
                    delete values[uniGold];
                    if(!values[statpak]){
                        delete values[hivStatus];
                        delete values[artReferral]
                        delete values[artCenter];
                        delete values[prepAvailable];
                        delete values[prepReferral];
                        delete values[prepcenter];
                    }
                }else if(values[determineType] && values[determineType] == "Uni-gold"){
                    delete values[statpak];
                    if(!values[uniGold]){
                        delete values[hivStatus];
                        delete values[artReferral]
                        delete values[artCenter];
                        delete values[prepAvailable];
                        delete values[prepReferral];
                        delete values[prepcenter];
                    }
                }
            }
        }*/

        if(fieldData.dataElement.id == statpak) { //statpak
            if(values[statpak] && values[statpak] != "Stat-pak reactive"){
                delete values[hivStatus];
                delete values[artReferral]
                delete values[artCenter];
            }else if(values[statpak] && values[statpak] == "Stat-pak reactive"){
                if(values[uniGold] && values[uniGold] == "Uni-gold Reactive"){
                    delete values[prepAvailable];
                    delete values[prepReferral];
                    delete values[prepcenter];
                }
            }
        }

        if(fieldData.dataElement.id == uniGold) { //uniGold
            if(values[uniGold] && values[uniGold] != "Uni-gold Reactive"){
                delete values[hivStatus];
                delete values[artReferral]
                delete values[artCenter];
            }else if(values[uniGold] && values[uniGold] == "Uni-gold Reactive"){
                if(values[statpak] && values[statpak] == "Stat-pak reactive"){
                    delete values[prepAvailable];
                    delete values[prepReferral];
                    delete values[prepcenter];
                }
            }
        }
        
        if(fieldData.dataElement.id == hivStatus) { //hivStatus
            if(values[hivStatus] && values[hivStatus] == "No"){
                //delete values[artReferral]
                //delete values[artCenter];
            }
        }
        if(fieldData.dataElement.id == artReferral) { //hivStatus
            if(values[artReferral] && values[artReferral] == "Onsite"){
                delete values[artCenter];
            }
        }

        if(fieldData.dataElement.id == prepAvailable) { //prepAvailable
            if(values[prepAvailable] && values[prepAvailable] == "No"){
                delete values[prepReferral]
                delete values[prepcenter];
            }
        }
        if(fieldData.dataElement.id == prepReferral) { //prepReferral
            if(values[prepReferral] && values[prepReferral] == "Deferred"){
                delete values[prepcenter];
            }
        }
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        if(fieldData.dataElement.id == "HBXuLtCgRHs") { //HTC service
            if(values['t94TTOWs3QI'] && values['OEJhAj3i1yX']) {
                if(values['t94TTOWs3QI'] && values['t94TTOWs3QI'] == 'NO' && values['OEJhAj3i1yX'] && values['OEJhAj3i1yX'] == 'YES'){
                    validationResult.hideShow = true;
                }
            }
            if(values['OEJhAj3i1yX'] && values['OEJhAj3i1yX'] == 'NO'){
                validationResult.hideShow = true;
            }
        }
        if(fieldData.dataElement.id == "VjhIY9DVce4") { //HTC service - testing
            if(!values['UcPCwWPERO1']) { //onsite
                validationResult.hideShow = false;
            }
        }
        if(fieldData.dataElement.id == "qnaAvZPwh42") {
            if(!values['VjhIY9DVce4']) {
                validationResult.hideShow = false;
            }
        }


        if(fieldData.dataElement.id == "UcPCwWPERO1") { //HTC service - onsite
            if(values['HBXuLtCgRHs'] && values['HBXuLtCgRHs'] == 'Onsite'){
                validationResult.hideShow = true;
            }
            //console.log("validationResult.hideShow ",validationResult.hideShow)
        }
        // if(fieldData.dataElement.id == "T2w3pT8DFeC") { // is prep available in HTC
        //     if(values['t94TTOWs3QI'] && values['t94TTOWs3QI'] == 'YES'){
        //         validationResult.hideShow = true;
        //     }
        // }
        //show on art
        
        
        if((newServiceData && newServiceData.isNewService) || !values["OEJhAj3i1yX"]){ //HTS 3 - Ever tested OEJhAj3i1yX
            if(values["tgft2rEpVts"] && values["tgft2rEpVts"] == "Yes"){ // HTC 4 - Is client comfortable to disclose HIV status to ORW tgft2rEpVts
                if(fieldData.dataElement.id == "OEJhAj3i1yX" 
                    || fieldData.dataElement.id == "HBXuLtCgRHs" // HBXuLtCgRHs HTS 6 - HTC services
                    || fieldData.dataElement.id == "ydFtqaCs0IV" // ydFtqaCs0IV HTS 4 - Client Status
                    || fieldData.dataElement.id == "t94TTOWs3QI" // HTS 5 - Tested in last 6 months
                    || fieldData.dataElement.id == "UcPCwWPERO1" // HTS 7 - Onsite
                    || fieldData.dataElement.id == "qnaAvZPwh42" // HTS 8 - Testing
                    || fieldData.dataElement.id == "T2w3pT8DFeC" // HTS 11 - Is PrEP available?
                    || fieldData.dataElement.id == "fbbEnmGrs7a" // HTS 12 - PrEP referral Services
                    || fieldData.dataElement.id == "Du1mvHcJlA5" // HTS 13 - PrEP referral
                || fieldData.dataElement.id ==  customfieldobj.HTCWheredidyoureceivetheART){ 
                    validationResult.hideShow = false;
                }else if(fieldData.dataElement.id == "u30iHcjgaz6"){
                    validationResult.hideShow = true;
                }
            }
        }
        //test result hide is patient disclose
        /*if(fieldData.dataElement.id == "tgft2rEpVts") { //Is client comfortable to disclose HIV status to ORW
            if((values['IfgPLHu0Pf3'] && values['IfgPLHu0Pf3'] == 'Uni-gold Reactive') || (values['EmKOoPr5JGU'] && values['EmKOoPr5JGU'] == 'Stat-pak reactive')){
                validationResult.hideShow = true;
            }else{
                validationResult.hideShow = false;
            }

        }*/

        //a7mQX6JvnqU - Is PrEP service available for client ?
        if(fieldData.dataElement.id == prepAvailable) {
            if(values[determineTest] && values[determineTest] == 'Determine Reactive Result' && (values[uniGold] && (values[uniGold] == 'Uni-gold Non-reactive' || values[uniGold] == 'Uni-gold Invalid')) && (values[statpak] && (values[statpak] == 'Stat-pak Non reactive' || values[statpak] == 'Stat-pak Invalid'))){
                validationResult.hideShow = true;
            }else{
                if(values[determineTest] && (values[determineTest] == 'Determine Non- reactive Result' || values[determineTest] == 'Determine Invalid Result')){
                    validationResult.hideShow = true;
                }else{
                    validationResult.hideShow = false;
                }
            }
            /*if((values[determineTest] && (values[determineTest] == 'Determine Non- reactive Result' || values[determineTest] == 'Determine Invalid Result')) || (values[uniGold] && (values[uniGold] == 'Uni-gold Non-reactive' || values[uniGold] == 'Uni-gold Invalid')) || (values[statpak] && (values[statpak] == 'Stat-pak Non reactive' || values[statpak] == 'Stat-pak Invalid'))){
                validationResult.hideShow = true;
            }else{
                validationResult.hideShow = false;
            }*/
        }
        setValidationResult(validationResult)
    }

    async function getMetaData() {
        let loginDetails = await OfflineDb.getDataFromPouchDB('loginDetails')
        //console.log("loginDetails",loginDetails)
        setSessionUserBoValue(loginDetails.data)
    }

    useEffect(() => {
        //console.log("loginDetailsloginDetails");
        getMetaData();
    }, [])
    
    useEffect(() => {
        getIcons()
    }, [])

    useEffect(() => {
        if (Array.isArray(icons)) {
            findFieldType()
            fetchOption()
            fetchValidation()
        }
        //fetchValidation()
    }, [icons, values,localStorage.getItem("locale")])

    useEffect(() => {
        //console.log("newServiceData",newServiceData,values);
        const userRoles = sessionUserBoValue?.userRoles || [];

        const roleNames = userRoles.map((role) => role.name);
        const isDataAdminPresent = roleNames.includes("Data  Administrator");

       

        if (validationResult != null && fieldType != null) {
            let isDisabled = false;
            if(stagesDataExist){
                 isDisabled = true;
                // if (!isDataAdminPresent) {
                //     const hasRelevantRole = roleNames.some((role) =>
                //         ["HTC", "ART user", "ART-I user", "ORW"].includes(role)
                //     );
                //         if (
                //             navigator.onLine &&
                //             sessionUserBoValue?.userCredentials &&
                //             hasRelevantRole 
                //             // && activeCaseDetails?.data?.trackedEntityInstance
                //         ) {
                //             isDisabled = true;
                //         }
                // }else{
                //     isDisabled = false; // Data Admin can edit all fields
                // }

                if(newServiceData && newServiceData.isNewService){
                    if(fieldData.dataElement.id == "svTN057036v"){ //ART referral service
                        isDisabled = false;
                    }
                }
            }
            // console.log("checkAllData",fieldData.dataElement.id,fieldData.dataElement.displayName,fieldType)
            if (fieldType == "text") {
                let defaultFieldValue = '';
                if(fieldData.dataElement.fieldMask ==  "Default Facility"){
                    let facility = OUJSON.filter(obj => obj.id == orgid)
                    defaultFieldValue = facility ? facility[0].name : ''
                }
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                        <Field
                            name={fieldData.dataElement.id}
                            label={getTranslatedLabels(fieldData.dataElement)}
                            type={'text'}
                            component={InputFieldFF}
                            key={fieldData.dataElement.id}
                            defaultValue={defaultFieldValue}
                            required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                            validate={composeValidators(required, scriptCheck)} //fieldData.compulsory && validationResult.hideShow == true ? hasValue : false
                            value=''
                            disabled={isDisabled}
                        />
                    </Grid>
                )
                if(fieldData.dataElement.id == "YmMhbvuwGZ1" || fieldData.dataElement.id == "Du1mvHcJlA5" || fieldData.dataElement.id == "oOaqOaQdzJ7" || fieldData.dataElement.id == "rubrYJZ78Ds"){
                    //let autocompleteData =[{id: "facility-1", label: "Facility 1", value: "facility-1"},{id: "facility-2", label: "Facility 2", value: "facility-2"},{id: "facility-3", label: "Facility 3", value: "facility-3"}]
                    let userOU = sessionUserBoValue ? sessionUserBoValue ? sessionUserBoValue.organisationUnits : null : null;
                    let autocompleteData = [];
                    let filterFac = [];
                    let defaultOption = null;
                    if(userOU){
                        userOU = _.filter(userOU,{"level":5,"comment":"Facility"})
                        userOU.map((fac) =>{
                            fac.attributeValues.map((c) =>{
                                if((fieldData.dataElement.id == "YmMhbvuwGZ1" || fieldData.dataElement.id == "Du1mvHcJlA5" || fieldData.dataElement.id == "oOaqOaQdzJ7") && c.attribute.id == "ZoTVvWClHe9" && c.value == "true"){ //PrEP Facility
                                    filterFac.push(fac);
                                }else if(fieldData.dataElement.id == "rubrYJZ78Ds" && c.attribute.id == "XbWlXexPdTb" && c.value == "true"){ //ART Facility
                                    filterFac.push(fac);
                                }
                            })
                        })
                    }
                    filterFac.map(facility=>{
                        let obj = {
                            'id': facility["id"],
                            'label': facility["displayName"],
                            'value': facility["id"],
                        }
                        autocompleteData.push(obj)
                        autocompleteData = _.orderBy(autocompleteData, ['label'],['asc'])
                        if(values && values[fieldData.dataElement.id] && values[fieldData.dataElement.id] == facility["id"]){
                            defaultOption = {
                                'id': values[fieldData.dataElement.id],
                                'label': facility["displayName"],
                                'value': values[fieldData.dataElement.id]
                            }
                        }
                    })
                    console.log("fieldData.dataElement.displayName",fieldData.dataElement.displayName)
                    
                    if (values && values[fieldData.dataElement.id]){
                        if(defaultOption != null){
                            setFieldStructure(
                                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                                    <Autocomplete
                                        name={fieldData.dataElement.id}
                                        label={getTranslatedLabels(fieldData.dataElement)}
                                        options={autocompleteData}
                                        values={''}
                                        getOptionSelected={(option, value) => option && value ? option.id === value.id : ''}
                                        defaultValue={defaultOption}
                                        getOptionValue={x => x.value}
                                        getOptionLabel={x => x.label}
                                        disabled={isDisabled}
                                        required={((
                                            fieldData.dataElement.displayName == "HTS 13 - PrEP referral" ||
                                            fieldData.dataElement.displayName == "HTS 16 - ART referral Center" 
                                        ) ||
                                            fieldData.compulsory) &&
                                             validationResult.hideShow == true ? true : false}
                                        //validate={composeValidators(requiredOptions)}
                                        //onChange={(event,value) => this.handleChange(event,value,attribute.dataElement)}
                                    />
                                </Grid>
                            )
                        }
                    }else{
                        setFieldStructure(
                            <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                                <Autocomplete
                                    name={fieldData.dataElement.id}
                                    label={getTranslatedLabels(fieldData.dataElement)}
                                    options={autocompleteData}
                                    values={''}
                                    getOptionSelected={(option, value) => option && value ? option.id === value.id : ''}
                                    defaultValue={''}
                                    getOptionValue={x => x.value}
                                    getOptionLabel={x => x.label}
                                    disabled={isDisabled}
                                    required={((
                                            fieldData.dataElement.displayName == "HTS 13 - PrEP referral" ||
                                            fieldData.dataElement.displayName == "HTS 16 - ART referral Center" 
                                        ) ||
                                            fieldData.compulsory) &&
                                             validationResult.hideShow == true ? true : false}
                                    // required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                                    //validate={composeValidators(requiredOptions)}
                                    //onChange={(event,value) => this.handleChange(event,value,attribute.dataElement)}
                                />
                            </Grid>
                        )
                    }

                }
                if(fieldData.dataElement.id === customfieldobj.facilityofArtInitiated){
                    validationResult.hideShow = false;
                }
                if((fieldData.dataElement.id === customfieldobj.dateofartInitiated ||
                    fieldData.dataElement.id === customfieldobj.facilityofArtInitiated 
                )&& values[customfieldobj.ARTinitiated] == "Yes"){
                    validationResult.hideShow = true;
                }
                if(fieldData.dataElement.id == "kPtU8JFvLy3" || fieldData.dataElement.displayName == customfieldobj.facilityofArtInitiated || fieldData.dataElement.fieldMask == customfieldobj.facilityofArtInitiated){
                    try{
                        let facOptions = localStorage.getItem("artEnrollmentFacilities");
                        facOptions = facOptions ? JSON.parse(facOptions) : [];
                        //console.log(localStorage.getItem("artEnrollmentFacilities"))
                        setFieldStructure(
                            <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                                <Autocomplete
                                    name={fieldData.dataElement.id}
                                    label={getTranslatedLabels(fieldData.dataElement)}
                                    options={facOptions}
                                    values={''}
                                    getOptionSelected={(option, value) => option && value ? option.id === value.id : ''}
                                    //defaultValue={defaultOption}
                                    getOptionValue={x => x.value}
                                    getOptionLabel={x => x.label}
                                    disabled={isDisabled}
                                    required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                                    //validate={composeValidators(requiredOptions)}
                                    //onChange={(event,value) => this.handleChange(event,value,attribute.dataElement)}
                                />
                            </Grid>
                        )
                    }catch(e){
                        console.log(e);
                    }
                    
                }
            } else if (fieldType == "radio") {
                //let isDisabled = false;
                //let isChecked = false;
                
                let FirstTimefld = "First time you receive Prevention services in your life?"
                if((fieldData.dataElement.displayName == FirstTimefld || (fieldData.dataElement.fieldMask && fieldData.dataElement.fieldMask == FirstTimefld))){
                    fieldData.compulsory = true;
                    validationResult.hideShow = true;
                }

                    if((fieldData.dataElement.id == customfieldobj.FirsttimeyoureceivePreventionservicesinyourlife) 
                    && values[customfieldobj.FirsttimeyoureceivePreventionservicesinyourlife] &&
                    customIsDisable == true 
                    ){ 
                        isDisabled = true;
                    }
                    if((fieldData.dataElement.id == customfieldobj.FirsttimeyoureceivePreventionservicesinyourlife) &&
                        values[customfieldobj.FirsttimeyoureceivePreventionservicesinyourlife] == "Yes" 
                    ){ 
                        values[customfieldobj.DidyoureceivePreventionservicesfromotherorganizationsinthisyear] = "No";
                    }
                    // else if(
                    //     (fieldData.dataElement.id == customfieldobj.FirsttimeyoureceivePreventionservicesinyourlife) &&
                    //     values[customfieldobj.FirsttimeyoureceivePreventionservicesinyourlife] == "No" 
                    // ){
                    //     values[customfieldobj.DidyoureceivePreventionservicesfromotherorganizationsinthisyear] = "";
                    // }

                if (fieldData.dataElement.id === customfieldobj.ARTreferralservice) {
                    if(values[customfieldobj.isclientcomfortabletodisclosehivstatustoorw] 
                        && values[customfieldobj.isclientcomfortabletodisclosehivstatustoorw] == "Yes"
                    && values[customfieldobj.patientenrolledincare] == "Yes"
                ||((!values[customfieldobj.HTCOnART] || values[customfieldobj.HTCOnART] == "Yes"))){
                        validationResult.hideShow = false;
                    }    
                    else if(values[customfieldobj.HTCOnART] == "No"){
                        validationResult.hideShow = true;
                    }
                  }

                //   if(fieldData.dataElement.id == customfieldobj.ARTreferralservice){
                //     // console.log("svTN057036v",fieldData, validationResult)
                //     if(!values[customfieldobj.HTCOnART] || values[customfieldobj.HTCOnART] == "Yes")
                //     validationResult.hideShow = false;
                // else
                //     validationResult.hideShow = true;
                // } 
                  
                if(fieldData.dataElement.id == "u30iHcjgaz6"){
                    if(values["tgft2rEpVts"] && values["tgft2rEpVts"] == "Yes"){
                       isDisabled = true;
                    }
                    if((newServiceData && newServiceData.isNewService) || !values["OEJhAj3i1yX"]){
                        
                        if(values["tgft2rEpVts"] && values["tgft2rEpVts"] == "Yes" && values["Bm6GvfF7OOj"] && values["Bm6GvfF7OOj"] == 'Yes'){
                            values["u30iHcjgaz6"] = 'Yes'
                        }else if(values["tgft2rEpVts"] && values["tgft2rEpVts"] == "Yes" && (!values["Bm6GvfF7OOj"] || (values["Bm6GvfF7OOj"] && values["Bm6GvfF7OOj"] == 'No'))){
                            values["u30iHcjgaz6"] = 'No'
                        }
                    }
                }
                if(fieldData.dataElement.id == "xo6qP2VjjBb" && values["VjhIY9DVce4"] != "Combo HIV & Syphilis test") {
                    validationResult.hideShow = false;
                }
                // console.log("check",fieldData.dataElement.displayName,fieldData.dataElement.id,fieldData)
                if (fieldData.dataElement.id === customfieldobj.HTCservices || fieldData.dataElement.id === customfieldobj.HTStestedinlast6months || fieldData.dataElement.id === customfieldobj.HTCOnART || fieldData.dataElement.id === customfieldobj.HTSriskexposure
                    || fieldData.dataElement.id === customfieldobj.HTCIsPrEPavailable 
                ) {
                    // Hide by default unless other conditions make it visible
                    validationResult.hideShow = false;
                }
                if(fieldData.dataElement.id === customfieldobj.HTCIsPrEPavailable  &&  values[customfieldobj.HTSriskexposure] == "NO"){
                    validationResult.hideShow = true;
                }
                if(fieldData.dataElement.id === customfieldobj.HTCIsPrEPservices && values[customfieldobj.HTCIsPrEPavailable] == "Yes"){
                    validationResult.hideShow = true;
                }
                if(fieldData.dataElement.id === customfieldobj.HTCPrEPreferral && (values[customfieldobj.HTCIsPrEPservices] == "Accompanied referral"
                    || values[customfieldobj.HTCIsPrEPservices] == "Referral")){
                    validationResult.hideShow = true;
                }
                // if(fieldData.dataElement.id === "t94TTOWs3QI" ){
                //     // HTS 5 - Tested in last 6 months
                //     console.log("hide")
                //     validationResult.hideShow = false;
                // }
                // if(fieldData.dataElement.id === "u30iHcjgaz6" ){
                //     // HTS 5 - Tested in last 6 months
                //     console.log("hide")
                //     validationResult.hideShow = false;
                // }
                // if(fieldData.dataElement.id == customfieldobj.HTCOnART &&(
                //     values[customfieldobj.isclientcomfortabletodisclosehivstatustoorw] == "Yes" && values[customfieldobj.patientenrolledincare] == "Yes" 
                // )){
                //     values[customfieldobj.HTCOnART] = "Yes"
                //     isDisabled = true;
                // }
                // else if(fieldData.dataElement.id == customfieldobj.HTCOnART &&(
                //     values[customfieldobj.isclientcomfortabletodisclosehivstatustoorw] == "No" && values[customfieldobj.patientenrolledincare] == "Yes" 
                // ) && newServiceData && newServiceData.isNewService){
                //     values[customfieldobj.HTCOnART] = "No"
                //     isDisabled = true;
                // }
                    
                if (
                    (fieldData.dataElement.id === customfieldobj.HTCservices || fieldData.dataElement.displayName === "HTS 6 - HTC services") &&
                    (values[customfieldobj.HTSclientStatus] === "Unknown" || values[customfieldobj.HTCEverTested] === "NO" || values[customfieldobj.HTStestedinlast6months] === "NO" || 
                         values[customfieldobj.HTSriskexposure] ==="YES")
                ) {
                    validationResult.hideShow = true;
                }
                
                // else if( (fieldData.dataElement.id === "OEJhAj3i1yX" || fieldData.dataElement.displayName == "HTS 3 - Ever tested") || ){
                //     validationResult.hideShow = true;
                // }
                else if((fieldData.dataElement.id === customfieldobj.HTStestedinlast6months || fieldData.dataElement.displayName == "HTS 5 - Tested in last 6 months") && values[customfieldobj.HTSclientStatus] === "Negative"){
                    validationResult.hideShow = true;
                }
                else if((fieldData.dataElement.id === customfieldobj.HTCOnART || fieldData.dataElement.displayName == "HTS 14 - On ART") && values[customfieldobj.HTSclientStatus] === "Positive"){
                    validationResult.hideShow = true;
                }
                else if((fieldData.dataElement.id === customfieldobj.HTSriskexposure || fieldData.dataElement.displayName == "HTS 17 - Risk Exposure")  && values[customfieldobj.HTStestedinlast6months] == "YES"){
                    // console.log("HTS-17",values["t94TTOWs3QI"],fieldData.dataElement.id)
                    validationResult.hideShow = true;
                }
                else if((fieldData.dataElement.id === customfieldobj.HTCIsPrEPavailable || fieldData.dataElement.displayName == "HTS 11 - Is PrEP available?")  && values["XVrmC4bUWra"] == "No"){
                    // console.log("HTS-17",values["t94TTOWs3QI"],fieldData.dataElement.id)
                    validationResult.hideShow = true;
                }else if((fieldData.dataElement.id === customfieldobj.HTCIsPrEPavailable || fieldData.dataElement.displayName == "HTS 11 - Is PrEP available?") && values["qnaAvZPwh42"] == "Negative"){
                    validationResult.hideShow = true;
                }
                
                // else if((fieldData.dataElement.id === "HBXuLtCgRHs" || fieldData.dataElement.displayName == "HTS 6 - HTC services" )  && values["XVrmC4bUWra"] == "Yes"){
                //     // console.log("HTS-17",values["t94TTOWs3QI"],fieldData.dataElement.id)
                //     validationResult.hideShow = true;
                // }
                // console.log("check",values["t94TTOWs3QI"],fieldData)
              
                
                
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true || validationResult.hideShow == undefined ? '' : 'hide'}>
                        <Radios
                            id={fieldData.dataElement.id}
                            label={getTranslatedLabels(fieldData.dataElement)}
                            name={fieldData.dataElement.id}
                            required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                            data={optionSet != null ? optionSet : []}
                            disabled={isDisabled}
                            validate={composeValidators(requiredOptions)}
                        />
                    </Grid>
                )

            } else if (fieldType == "dropdown") {
                if(fieldData.dataElement.id == "Rc0D1mmFu8K") {
                    if(values['ZTQ487xJDkp'] == "Yes") {
                        values['Rc0D1mmFu8K'] = "Positive"
                    }

                }
                // console.log("fieldData.dataElement.id",fieldData.dataElement)
                if(
                    fieldData.dataElement.id === customfieldobj.ReasonsfornotARTinitiated ||
                    fieldData.dataElement.id === customfieldobj.dateofartInitiated ||
                    fieldData.dataElement.id === customfieldobj.facilityofArtInitiated 
                ){
                    validationResult.hideShow = false;
                }
                if(fieldData.dataElement.id === customfieldobj.ReasonsfornotARTinitiated && values[customfieldobj.ARTinitiated] == "No"){
                    validationResult.hideShow = true;

                }
                if((fieldData.dataElement.id === customfieldobj.dateofartInitiated ||
                    fieldData.dataElement.id === customfieldobj.facilityofArtInitiated 
                )&& values[customfieldobj.ARTinitiated] == "Yes"){
                    validationResult.hideShow = true;
                }
                // isDisabled = fieldData.dataElement.attributeValues && fieldData.dataElement.attributeValues.length > 0 ? fieldData.dataElement.attributeValues[0].attribute.name == 'isDisabled' ? true  : stagesDataExist : stagesDataExist
                // console.log("checkDrop",fieldData.dataElement.id,fieldData.dataElement.displayName,fieldData)
                // if( fieldData.dataElement.id === "w594LbsoBjx"  ||  fieldData.dataElement.id === "CCc3zVpaXEo"){
                //      // Hide by default unless other conditions make it visible
                //      validationResult.hideShow = false;
                // }
                if(validationResult.hideShow == true) {
                    setFieldStructure(
                        <Grid item xs={12} sm={4} md={4}>
                            <Field
                                id={fieldData.dataElement.id}
                                name={fieldData.dataElement.id}
                                label={getTranslatedLabels(fieldData.dataElement)}
                                // type={fieldData.dataElement.valueType}
    
                                component={SingleSelectFieldFF}
                                key={fieldData.dataElement.id}
                                //validate= {fieldData.compulsory && validationResult.hideShow == true ? hasValue: false}
                                validate={composeValidators(requiredOptions)}
                                required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                                options={optionSet != null ? optionSet : []}
                                // disabled={fieldData.dataElement.attributeValues && fieldData.dataElement.attributeValues.length > 0 ? fieldData.dataElement.attributeValues[0].attribute.name == 'isDisabled' ? isDisabled  : stagesDataExist : stagesDataExist}
                                disabled={isDisabled}
                            // onChange={() => this.onDropdownOptionChange(attribute.dataElement)}
                            />
                        </Grid>
                    )
                } else {
                    setFieldStructure(
                        <Grid item xs={12} sm={4} md={4} className={'hide'}>
                            <Field
                            name={fieldData.dataElement.id}
                            label={getTranslatedLabels(fieldData.dataElement)}
                            type={'text'}
                            component={InputFieldFF}
                            key={fieldData.dataElement.id}
                            required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                            validate={composeValidators(required, scriptCheck)} //fieldData.compulsory && validationResult.hideShow == true ? hasValue : false
                            value=''
                            disabled={isDisabled}
                        />
                        </Grid>
                    )
                }
                
            }
        }


    }, [fieldType, optionSet, validationResult,sessionUserBoValue,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function DateFieldConfig(props) {
    const { t } = useTranslation();
    let fieldData = props.fieldData
    let newServiceData = props.newServiceData
    let stagesDataExist = props.stagesData ? props.stagesData.length > 0 ? true : false : false;
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let customfieldobj = props.customfieldobj
    let values = props.values
    let dataElementGroup = props.dataElementGroup
    let showYear = fieldData.dataElement.attributeValues.length > 0 && fieldData.dataElement.attributeValues[0].attribute.name == "showyear" ? true : false
    let hideField = fieldData.dataElement.attributeValues.length > 0 && fieldData.dataElement.attributeValues[0].attribute.name == "hideField" ? true : false
    const [fieldStructure, setFieldStructure] = useState(null)
    const [selectedDate, setDate] = useState(new Date());
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        let isDisabled = false;
        //console.log("fieldData.dataElement ",fieldData.dataElement.displayName,Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup))
        // if(values["Bm6GvfF7OOj"] && values["Bm6GvfF7OOj"] == 'Yes' && !values[fieldData.dataElement.id]){
        //     values[fieldData.dataElement.id] = selectedDate;
        // }else if(values["Bm6GvfF7OOj"] && values["Bm6GvfF7OOj"] == 'No'){
        //     delete values[fieldData.dataElement.id]
        // }
        if (validationResult != null) {
            let isDisabled = false;
            if(stagesDataExist){
                isDisabled = true;
                if(newServiceData && newServiceData.isNewService){
                    if(fieldData.dataElement.displayName == "Date of Testing" || fieldData.dataElement.fieldMask == "Date of Testing"){ 
                        isDisabled = false;
                    }
                }
            }
            if((fieldData.dataElement.displayName == "Date of Testing" || (fieldData.dataElement.fieldMask && fieldData.dataElement.fieldMask == "Date of Testing"))){
                fieldData.compulsory = true;
                validationResult.hideShow = true;
            }
            if(fieldData.dataElement.id === customfieldobj.dateofartInitiated){
                validationResult.hideShow = false;
            }
            if((fieldData.dataElement.id === customfieldobj.dateofartInitiated ||
                fieldData.dataElement.id === customfieldobj.facilityofArtInitiated 
            )&& values[customfieldobj.ARTinitiated] == "Yes"){
                validationResult.hideShow = true;
            }
            
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <DatePicker

                        disabled={isDisabled ? true : false}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        name={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        dateFunsUtils={DateFnsUtils}
                        // value={values[fieldData.dataElement.id] == undefined ? selectedDate : values[fieldData.dataElement.id]}
                        margin="normal1"
                        variant="inline"
                        className={hideField ? "hide" : ""}
                        format={showYear == true ? "yyyy" : "yyyy-MM-dd"}
                        //validate={selectedDate.compulsory && validationResult.hideShow == true ? hasValue : false}
                        fieldProps={{
                        validate: (value) =>
                            value
                            ? undefined
                            : fieldData.compulsory && validationResult.hideShow == true
                                ? t("Required")
                                : false,
                        }}
                        disableFuture={fieldData.allowFutureDate ? fieldData.allowFutureDate : false}
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}

function DateTimeFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup
    let showYear = fieldData.dataElement.attributeValues.length > 0 && fieldData.dataElement.attributeValues[0].attribute.name == "showyear" ? true : false
    const [fieldStructure, setFieldStructure] = useState(null)
    const [selectedDate, setDate] = useState(new Date());
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <DateTimePicker
                        disabled={showYear ? true : false}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        name={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        dateFunsUtils={DateFnsUtils}
                        // value={values[fieldData.dataElement.id] == undefined ? selectedDate : values[fieldData.dataElement.id]}
                        margin="normal"
                        variant="inline"
                        format={showYear == true ? "yyyy" : "yyyy-MM-dd"}
                        validate={selectedDate.compulsory && validationResult.hideShow == true ? hasValue : false}
                        disableFuture={fieldData.allowFutureDate ? fieldData.allowFutureDate : false}
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}

function AgeFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup
    const {t} = useTranslation()
    const required = value => (fieldData.compulsory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)
    const mustBeNumber = value => (isNaN(value) && value ? t('Must be a number') : undefined)
    const minValue = min => value =>
        isNaN(value) || value >= min ? undefined : t('Should be greater than')+min
    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        type="number"
                        component={InputFieldFF}
                        key={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, mustBeNumber)}
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function PhoneNumberFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup
    const {t} = useTranslation()
    const numberFormat = value =>
        isNaN(value) && value ? t(`Incorrect format`) : undefined

    const maxLength = max => value => value ? isNaN(value) || value.length > max ? t('Should be less than')+max : undefined : undefined
    const required = value => (fieldData.compulsory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)

    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        type={'number'}
                        component={InputFieldFF}
                        key={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, numberFormat, maxLength(12))}
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function EmailFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup

    const EMAIL_ADDRESS_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i

    const invalidEmailMessage = 'Please provide a valid email address'

    const email = value =>
        isEmpty(value) || (isString(value) && EMAIL_ADDRESS_PATTERN.test(value))
            ? undefined
            : invalidEmailMessage

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        type={'email'}
                        component={InputFieldFF}
                        key={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        validate={email}

                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function DefaultValueField(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup
    const [UIC, setUIC] = useState(null)

    async function getUIC() {
        if(UIC == null ) {
            let getUIC = await apiServices.generateUIC(fieldData.dataElement.id)
            setUIC(getUIC.value)
        }
        
    }
    useEffect(() => {
        getUIC()
    }, [])

    return (
        <>
            {UIC != null ?
                <Grid item xs={12} sm={4} md={4}>
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        type={fieldData.dataElement.valueType}
                        component={InputFieldFF}
                        key={fieldData.dataElement.id}
                        defaultValue={UIC}
                        disabled={true}
                    />
                </Grid>
                :
                <> </>
            }
        </>
    )
}

function DefaultStageValueField(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup
    const [randomNumber, setRandomNumber] = useState(null)

    async function getRandomNumber() {
        if(randomNumber == null) {
            let param = {
                length : 8
            }
            let getRandomNumber = await apiServices.generateRandomNumber(param)
            setRandomNumber(getRandomNumber.random)
        }
        
    }
    useEffect(() => {
        getRandomNumber()
    }, [])

    return (
        <>
            {randomNumber != null ?
                <Grid item xs={12} sm={4} md={4}>
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        type={fieldData.dataElement.valueType}
                        component={InputFieldFF}
                        key={fieldData.dataElement.id}
                        defaultValue={randomNumber}
                        disbaled={true}
                    />
                </Grid>
                :
                <> </>
            }
        </>
    )
}

function BooleanFieldConfig(props) {
    
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup
    const switchData = [
        { label: 'Yes', value: 'item1' },
    ];

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        
        if (validationResult != null) {
            if(fieldData.dataElement.id == "PUp1aEwZtVB") { //TB do you want to receive service
                if(!values['H7vi6um0FMY'] || values['H7vi6um0FMY'] == "No") {
                    validationResult.hideShow = false
                }
    
            }
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Switches
                        label={getTranslatedLabels(fieldData.dataElement)}
                        name={fieldData.dataElement.id}
                        disableRipple
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        data={switchData}
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function TimeFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup
    let showYear = fieldData.dataElement.attributeValues.length > 0 && fieldData.dataElement.attributeValues[0].attribute.name == "showyear" ? true : false
    const [fieldStructure, setFieldStructure] = useState(null)
    const [selectedDate, setDate] = useState(new Date());
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <TimePicker
                        label={fieldData.dataElement.displayFormName}
                        name={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        dateFunsUtils={DateFnsUtils}
                        margin="normal"
                        variant="inline"
                        format="HH:MM"
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}

function IntegerConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let customfieldobj = props.customfieldobj
    let dataElementGroup = props.dataElementGroup
    const {t} = useTranslation()
    const required = value => (fieldData.compulsory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)
    const mustBeNumber = value => (isNaN(value) && value ? 'Must be a number' : undefined)
    const minValue = min => value =>
        isNaN(value) || value >= min ? undefined : t('Should be greater than')+min

    const maxValue = max => value =>
        isNaN(value) || value <= max ? undefined : t('Should be less than')+max

    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)

        if(values[customfieldobj.CommoditiesDidclientacceptcondoms] == "Yes" &&
            (fieldData.dataElement.id == customfieldobj.CommoditiesNumberofMalecondomsprovided || 
                fieldData.dataElement.id == customfieldobj.CommoditiesNumberofFemalecondomsprovided)){
                validationResult.hideShow = true;
        }else if(fieldData.dataElement.id == customfieldobj.CommoditiesNumberofMalecondomsprovided || 
            fieldData.dataElement.id == customfieldobj.CommoditiesNumberofFemalecondomsprovided){
            validationResult.hideShow = false;
        }
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        type={'number'}
                        component={InputFieldFF}
                        key={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, mustBeNumber, minValue(0))}
                        value=''
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function TextAreaConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup
    const {t} = useTranslation()
    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    const required = value => (fieldData.compulsory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)
    const scriptCheck = value => (value ? value.match(/<[^>]*>/g) != null ? t('Incorrect expression "< or >" added as input') : undefined : undefined)
    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        type={'text'}
                        component={InputFieldFF}
                        key={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, scriptCheck)}
                        autoGrow
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function UserNameConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup
    let orgunitid = props.programorgid
    const [dropdownOptions, setDropdownOptions] = useState([])
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }
    function fetchCustomUsersList(){
        
        setGlobalSpinner(true)
        let options = [];
        apiServices.getAPI('users?paging=true&page=1&pageSize=10&query=&fields=firstName,surname,userCredentials[username],id&ou='+orgunitid)
        .then(response => {
            setGlobalSpinner(false)
            
            response.data.users.map(user => {
                let obj = {
                    'id': user.username,//user.id,
                    'label': user.firstName +" "+user.surname,
                    'value': user.username//user.id,
                }
                options.push(obj)
            })
            setDropdownOptions(options)
            setGlobalSpinner(false)
        }).catch(err=>{
            setGlobalSpinner(false)
           
        })
        
    }
    /*useEffect(()=>{
        //fetchCustomUsersList();
    },[])*/
    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null && dropdownOptions.length > 0) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? 'hide' : 'hide'}>
                    {/* old code commented
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        component={TextAreaFieldFF}
                        key={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(hasValue, dhis2Username)}
                    /> */}
                    <Field
                        id={fieldData.dataElement.id}
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        //component={SingleSelectFieldFF}
                        component={InputFieldFF}
                        key={fieldData.dataElement.id}
                        //validate= {fieldData.compulsory && validationResult.hideShow == true ? hasValue: false}
                        //required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        //options={dropdownOptions}
                        disabled={fieldData.dataElement.attributeValues && fieldData.dataElement.attributeValues.length > 0 ? fieldData.dataElement.attributeValues[0].attribute.name == 'isDisabled' ? true : false : false}
                    />
                </Grid>
            )
        }

    }, [validationResult,dropdownOptions,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function URLConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup
    let regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
    const {t} = useTranslation()
    const required = value => (fieldData.compulsory && validationResult.hideShow == true ? value ? undefined : t('Required') : undefined)

    const URLCheck = value => (regexp.test(value) ? undefined : t('Incorrect URL format'))

    const composeValidators = (...validators) => value =>
        validators.reduce((error, validator) => error || validator(value), undefined)

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                    <Field
                        name={fieldData.dataElement.id}
                        label={getTranslatedLabels(fieldData.dataElement)}
                        component={TextAreaFieldFF}
                        key={fieldData.dataElement.id}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        validate={composeValidators(required, URLCheck)}
                    />
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function HandleOUOptions(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let OUMappingList = OUMapping(values)
    let parentValue = OUMappingList[fieldData.dataElement.id] != undefined ? values[OUMappingList[fieldData.dataElement.id].parent] : null
    let programData = props.programData
    let options= props.options
    let defaultOption= props.defaultOption
    let stagesData = props.stagesData
    let newServiceData = props.newServiceData
    let townshipList = props.townshipList
    let customfieldobj = props.customfieldobj
    
    let rules = {
       "programRule": props.programRules,
       "programRuleVariable":props.programRulesVariables
    }
    let OUJSON = props.OUJSON.organisationUnits
    /*if(fieldData.dataElement.displayName == "Referral facility" || fieldData.dataElement.displayName == "Sample transferred to facility "){
        OUJSON = OUJSON.filter(obj => obj.comment == "Facility")
    }*/

    const option = { "id": "option1", "label": 'Option1', "value": 'option1' }

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)
    const [location, setLocation] = useState([])
    const [sessionUserBoValue, setSessionUserBoValue] = useState(null)
    
    const setGlobalSpinner = useGlobalSpinnerActionsContext()

    async function getMetaData() {
        let loginDetails = await OfflineDb.getDataFromPouchDB('loginDetails')
        //console.log("loginDetails",loginDetails)
        setSessionUserBoValue(loginDetails.data)
    }

    useEffect(() => {
        //console.log("loginDetailsloginDetails");
        getMetaData();
    }, [])

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables)
        setValidationResult(validationResult)
    }


    useEffect(() => {
        
        if(options != '') {
            let locationList = []
            const filterOnId = OUJSON.filter(obj => obj.id == options)
            console.log("filterOnID",filterOnId)
            if(filterOnId.length > 0 ) {
                const childrenOptions = filterOnId[0].children
                childrenOptions.map(childOptions => {
                    const filterChildDetails = OUJSON.filter(obj => obj.id == childOptions.id)
                    if(filterChildDetails.length > 0) {
                        let obj = {
                            'id': filterChildDetails[0].id,
                            'label': filterChildDetails[0].name,
                            'value': filterChildDetails[0].id,
                        }
                        locationList.push(obj)
                        console.log("location",locationList)
                        setLocation(locationList)
                    }
                    
                    
                })
                
            }
            /*if(fieldData.dataElement.displayName == "Referral facility" || fieldData.dataElement.displayName == "Sample transferred to facility "){
                
                OUJSON.map(facility=>{
                    let obj = {
                        'id': facility["id"],
                        'label': facility["name"],
                        'value': facility["id"],
                    }
                    locationList.push(obj)
                    locationList = _.orderBy(locationList, ['label'],['asc'])
                    setLocation(locationList)
                })
            }*/
        } else {
            /*const OUList = programData.organisationUnits
            let autocompleteData = []
            
            if (OUMappingList[fieldData.dataElement.id] != undefined) {
                if (OUMappingList[fieldData.dataElement.id].type) {
                    
                    let OUOptions = OUJSON.filter(obj => obj.level == OUMappingList[fieldData.dataElement.id].level)
                    if(OUOptions.length > 0) {
                        OUOptions.map(items => {
                            let obj = {
                                'id': items.id , 
                                'label': items.name, 
                                'value': items.id
                            }
                            autocompleteData.push(obj)
                        })
                        setLocation(autocompleteData)
                    }
                }
            }*/
            let autocompleteData = []
            let OUResponse = sessionUserBoValue ? sessionUserBoValue ? sessionUserBoValue.organisationUnits : null : null;
            //https://eosavemyn.imonitorplus.com/service/api/29/organisationUnits?filte:attributeValues:ilike:id=XbWlXexPdTb&paging=false
            console.log(OUResponse)
            if(OUResponse){
                OUResponse = _.filter(OUResponse,{"level":5,"comment":"Facility"})
                let filterFac = [];
                if(fieldData.dataElement.id && fieldData.dataElement.id == "ZHoqyBa59km"){
                    OUResponse.map((fac) =>{
                        fac.attributeValues.map((c) =>{
                            if(c.attribute.id == "VORKWEMR5gE" && c.value == "true"){ //c.attribute.name == "HTC Facility" 
                                filterFac.push(fac);
                            }
                        })
                    })
                }else if(fieldData.dataElement.id && fieldData.dataElement.id == "ppnkyJJlASL"){
                    OUResponse.map((fac) =>{
                        fac.attributeValues.map((c) =>{
                            if(c.attribute.id == "guk3p3nUWMq" && c.value == "true"){ //c.attribute.name == "STI Facility"
                                filterFac.push(fac);
                            }
                        })
                    })
                }else if(fieldData.dataElement.id == "JsObII1YufJ"){
                    OUResponse.map((fac) =>{
                        fac.attributeValues.map((c) =>{
                            if(c.attribute.id == "C0v6BAMvyRZ"  && c.value == "true"){ //c.attribute.name == "TB Facility"
                                filterFac.push(fac);
                            }
                        })
                    })
                }else if(fieldData.dataElement.id == "LEP6NIPQ0pZ" ||
                    fieldData.dataElement.id == customfieldobj.facilityofEnrollment){
                    OUResponse.map((fac) =>{
                        fac.attributeValues.map((c) =>{
                            if(c.attribute.id == "XbWlXexPdTb" && c.value == "true"){ //c.attribute.name == "ART Facility"
                                filterFac.push(fac);
                            }
                        })
                    })
                }
                filterFac.map(facility=>{
                    let obj = {
                        'id': facility["id"],
                        'label': facility["displayName"],
                        'value': facility["id"],
                    }
                    autocompleteData.push(obj)
                    autocompleteData = _.orderBy(autocompleteData, ['label'],['asc'])
                    setLocation(autocompleteData)
                })
            }
            // if(fieldData.dataElement.displayName == "HTS 18 - Where did you receive the ART?"){
            //     let OUAPI = 
            //     JSON.parse(localStorage.getItem("OUAPI"))
            //     OUAPI.map(facility=>{
            //         let obj = {
            //             'id': facility["id"],
            //             'label': facility["displayName"],
            //             'value': facility["id"],
            //         }
            //         autocompleteData.push(obj)
            //         autocompleteData = _.orderBy(autocompleteData, ['label'],['asc'])
            //         setLocation(autocompleteData)
            //     })
            // }
            console.log(props.townshipList)
            if(fieldData.dataElement.displayName == "HTS 18 - Where did you receive the ART? (Township)" || fieldData.dataElement.id == customfieldobj.HTCWheredidyoureceivetheART
                || fieldData.dataElement.id == customfieldobj.facilityofArtInitiatedTownship || fieldData.dataElement.id == customfieldobj.HTC10Id
            ){
                    let OUAPI = townshipList
                    OUAPI.data.data.map(locations=>{
                        let obj = {
                            'id': locations.townuid,
                            'label': localStorage.getItem("locale") && localStorage.getItem("locale") == 'my' && locations.translations ? locations.translations : locations.townname,
                            'value': locations.townuid,
                            'code': locations.towncode ? locations.towncode : null
                        }
                        autocompleteData.push(obj)
                        autocompleteData = _.orderBy(autocompleteData, ['label'],['asc'])
                        setLocation(autocompleteData)
                    })
               }
            //    if(fieldData.dataElement.displayName == "HTS 18 - Where did you receive the ART?" || fieldData.dataElement.id == "CCc3zVpaXEo"){
            //     validationResult.hideShow = false;
            //    }
               if(fieldData.dataElement.displayName == "HTS 19 - Where did you receive the ART? (Facilities)" || fieldData.dataElement.id == "CCc3zVpaXEo"){
                let OUAPI = townshipList
                OUAPI = _.filter(OUAPI.data.data,{ townuid:values[customfieldobj.HTCWheredidyoureceivetheART], artflag:"true"})
                    //console.log("township",OUAPI,townshipList)
                    // console.log(values["w594LbsoBjx"])
                    if(OUAPI && OUAPI.length>0){
                        OUAPI.map(locations=>{
                            let obj = {
                                'id': locations.facilityuid ,
                                'label': localStorage.getItem("locale") && localStorage.getItem("locale") == 'my' && locations.fac_translation ? locations.fac_translation : locations.facility_name,
                                'value': locations.facilityuid,
                                // 'code': locations.towncode ? locations.towncode : null
                            }
                            autocompleteData.push(obj)
                            autocompleteData = _.orderBy(autocompleteData, ['label'],['asc'])
                            setLocation(autocompleteData)
                        })
                    }
               }
               if(fieldData.dataElement.id == customfieldobj.facilityofArtInitiated){
                let OUAPI = townshipList
                OUAPI = _.filter(OUAPI.data.data,{ townuid:values[customfieldobj.facilityofArtInitiatedTownship], artflag:"true"})
                    //console.log("township",OUAPI,townshipList)
                    // console.log(values["w594LbsoBjx"])
                    if(OUAPI && OUAPI.length>0){
                        OUAPI.map(locations=>{
                            let obj = {
                                'id': locations.facilityuid ,
                                'label': localStorage.getItem("locale") && localStorage.getItem("locale") == 'my' && locations.fac_translation ? locations.fac_translation : locations.facility_name,
                                'value': locations.facilityuid,
                                // 'code': locations.towncode ? locations.towncode : null
                            }
                            autocompleteData.push(obj)
                            autocompleteData = _.orderBy(autocompleteData, ['label'],['asc'])
                            setLocation(autocompleteData)
                        })
                    }
               }
            if((fieldData.dataElement.displayName == "Secondary Hotspot"
             || (fieldData.dataElement.fieldMask && (fieldData.dataElement.displayName== "Secondary Hotspot")))
             && sessionUserBoValue){
                let OUResponse = sessionUserBoValue ? sessionUserBoValue.organisationUnits ? _.filter(sessionUserBoValue.organisationUnits,{"level":6}) : [] : [];
                   if(OUResponse && OUResponse.length > 0){
                        //OUResponse = _.filter(OUResponse,{"level":6})
                        OUResponse.map(facility=>{
                            let obj = {
                                'id': facility["id"],
                                'label': facility["displayName"],
                                'value': facility["id"],
                            }
                            autocompleteData.push(obj)
                            autocompleteData = _.orderBy(autocompleteData, ['label'],['asc'])
                            setLocation(autocompleteData)
                        })
                    }
            }


            // condition on art initiated
                  if(fieldData.dataElement.id == customfieldobj.HTCWheredidyoureceivetheART ){
                    if(values[customfieldobj.HTCOnART] === "No") {
                      
                      delete values[customfieldobj.HTCWheredidyoureceivetheART]
                    }
                  }

            /*if(fieldData.dataElement.displayName == "Referral facility" || fieldData.dataElement.displayName == "Sample transferred to facility "){
                
                OUJSON.map(facility=>{
                    let obj = {
                        'id': facility["id"],
                        'label': facility["name"],
                        'value': facility["id"],
                    }
                    autocompleteData.push(obj)
                    autocompleteData = _.orderBy(autocompleteData, ['label'],['asc'])
                    setLocation(autocompleteData)
                })
            }*/

        }
        
    }, [values[fieldData.dataElement.id], parentValue, options,values,sessionUserBoValue, localStorage.getItem("locale")]) //defaultOption, options

    useEffect(() => {
            if(location != null) {
                console.log("orgname",fieldData.dataElement.displayName,location);
                if(values[fieldData.dataElement.id]) {
                    if(!_.isEmpty(defaultOption)) {
                        setFieldStructure(
                            <OUFieldConfig 
                                data={fieldData} values={values} rules={rules} options={location} defaultOption={defaultOption} programData={programData} OUMapping={OUMappingList} stagesData={stagesData} newServiceData={newServiceData}
                                customfieldobj={customfieldobj}
                            />
                        )
                    }
                }else {
                    setFieldStructure(
                        <OUFieldConfig 
                            data={fieldData} values={values} rules={rules} options={location} defaultOption={defaultOption} programData={programData} OUMapping={OUMappingList} stagesData={stagesData} newServiceData={newServiceData}
                            customfieldobj={customfieldobj}
                        />
                    )
                }
            }
            
        
    }, [location,values,localStorage.getItem("locale")])
    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function ReferalConfig(props) {
    let fieldData = props.fieldData
    
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup
    let programData = props.programData
    
    const stagesList = programData.programStages
    const {t} = useTranslation()
    let checkboxData = [];
    let isCheckboxReadOnly = false, readOnlyCheckboxArr = []

    let ReferToLabForinvestigationFieldValue = values['M6SKB9heIlP'] ? values['M6SKB9heIlP'] : undefined
    let defaultval = '';//"ZZcqCX95AmO";
    let hideStages = [];
    let referralField = fieldData.dataElement.id;
    let currentStage = props.stage;
    let currentStageID = currentStage ? currentStage[0].programStage.id : 'd7NYjKu2SCY';
    //console.log("props ",props,currentStageID);
    let prgramVariableReferralDisplayName = '';
    let testingStage = stagesList.filter(obj => obj.description == "Testing Form")
    if(testingStage && testingStage.length > 0){
        if( ReferToLabForinvestigationFieldValue == 'TB' || ReferToLabForinvestigationFieldValue == 'LTBI') {
            defaultval = testingStage[0].id
        }
        
    }

    //for save mynmar refer logic
    let referStage = stagesList.filter(obj => obj.description == "Test Result")
    if(currentStageID == "d7NYjKu2SCY" || currentStageID == "CYOIOf9hyHL"){ //htc service
        referStage = stagesList.filter(obj => obj.description == "Test Result")
        defaultval = referStage[0].id
        if(values && values["u30iHcjgaz6"] && values["u30iHcjgaz6"] == "NO" && values["svTN057036v"] && (values["svTN057036v"] == 'Referral' || values["svTN057036v"] == 'Accompanied Referral') && values['rubrYJZ78Ds']){
            referStage = stagesList.filter(obj => obj.description == "ART Enrollment")
            defaultval = referStage[0].id
        }
    }else if(currentStageID == "ZZcqCX95AmO"){ //test result service
        referStage = stagesList.filter(obj => obj.description == "ART Enrollment")
        defaultval = referStage[0].id
    }else if(currentStageID == "s62gtsI2DAB"){ 
        if(values && values["Bm6GvfF7OOj"] == "Yes"){//ART 1 - Receive ART enrollment is YES
        referStage = stagesList.filter(obj => obj.description == "ART Initiation")
        defaultval = referStage[0].id
    }}
    //Condition:
    // if ART 1 - Receive ART enrollment is YES, the client will be referred to the new ART Initiation stage.
 
    //end
    if(values && values['wsdFGlwnaOP'] && defaultval){
        values['wsdFGlwnaOP'] = [];
        values['wsdFGlwnaOP'].push(defaultval);
    }
    if(values && values['LUmtLdsG4Am'] && defaultval){
        values['LUmtLdsG4Am'] = [];
        values['LUmtLdsG4Am'].push(defaultval);
    }
    /*if(referralField){
        programRulesVariables.map((fRule) => {
            if(fRule["dataElement"] && fRule["dataElement"]["id"] == referralField){
              prgramVariableReferralDisplayName = fRule["displayName"]
              programRules.map((pRule) => {
                var curMatch = pRule.condition ? pRule.condition.match(/\{(.*?)\}/) : '';//rxp.exec( pRule.condition ) 
                if(curMatch && curMatch.length > 0 && curMatch[1] == prgramVariableReferralDisplayName && currentStageID == pRule.programStage.id){
                  pRule.programRuleActions.map((pAction) => {
                    hideStages.push(pAction.programStage.id)
                  })
                }
              })
            }
        })
      }
      console.log("hideStages",hideStages)
    //then we need remove thoes stages from stagelist
    stagesList.map((stage,index) => {
        hideStages.forEach((hStage) => {
        if(stage.id == hStage){
            delete stagesList[index];
        }
        })
    })
    //then add thoes stages to referral checkboxes
    stagesList.map((stage) => {
        readOnlyCheckboxArr.push(stage.id)
        isCheckboxReadOnly = true;
        checkboxData.push({
        label: stage.description,
        value: stage.id,
        });
    })
    console.log("stagesList",stagesList)*/
    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    function getFieldDetails(stage, parentAttribute, parentReadOnlyCheckboxArr) {
        return (
            <Field
                type="checkbox"
                component={CheckboxFieldFF}
                name={parentAttribute.dataElement.id}
                label={stage.label}
                value={stage.value}
                disabled={true}
                initialValue={parentReadOnlyCheckboxArr}
            />
        );
    };

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        
        if (validationResult != null) {
            if(fieldData.dataElement.id == "LUmtLdsG4Am"){
                validationResult.hideShow = false;
            }
            stagesList.map((stage) => {
                // readynoly checkbox logic for savemynmar
                if (stage.attributeValues.length > 0) {
                    stage.attributeValues.map((val) => {

                        if (val.attribute.displayName == "showStageNameInReferralService" && val.value == 'true') {
                            if(stage.id == defaultval){
                                readOnlyCheckboxArr.push(stage.id)
                            }
                            isCheckboxReadOnly = true;
                            checkboxData.push({
                                label: t(stage.description),
                                value: stage.id,
                            });
                        }
                    })
                }
            })
            setFieldStructure(
                <Grid item xs={12} sm={4} className={validationResult.hideShow == true ? 'customLoc' : 'hide'}>
                    <FieldGroupFF
                        label={getTranslatedLabels(fieldData.dataElement)}
                        required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                        name={fieldData.dataElement.id}
                    >
                        {checkboxData.map((stage) => {
                            return getFieldDetails(stage, fieldData, readOnlyCheckboxArr);
                        })}
                    </FieldGroupFF>
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function MultiSelectConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let DataElementGroup = props.DataElementGroup
    
    let programObj = props.programObj
    let dataElementGroup = props.dataElementGroup
    let stage = props.stages

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    function getFieldDetails(fieldId, formValues) {
        const getFieldsAttributes = stage.filter(
            (obj) => obj.dataElement.id == fieldId
        );

        if (getFieldsAttributes.length > 0) {

            const fieldData = getFieldsAttributes[0];
            // readynoly checkbox logic for savemynmar
            let isCheckboxReadOnly = false, readOnlyCheckboxArr = [];
            if(fieldData.dataElement.attributeValues.length > 0){
                fieldData.dataElement.attributeValues.map((val)=>{
                  //console.log('this.props.DataElementGroup',this.props.DataElementGroup)
                  if(val.attribute.displayName === "showText"){
                    DataElementGroup.dataElements.map(de=>{
                      readOnlyCheckboxArr.push(de.id)
                    })
                    isCheckboxReadOnly = true;
                  }
                  console.log('readOnlyCheckboxArr',readOnlyCheckboxArr)
                })
              }
        
              if(fieldData.dataElement.id == "A9ViHg2dAnU" || fieldData.dataElement.id == "OCu38UY9V0L" || fieldData.dataElement.id == "K5RxgT0Jnsh" || fieldData.dataElement.id == "iRw6LO2BUja") {
                if(values['Bo3avY8dlk4'] == 'true' || values['Bo3avY8dlk4'] == true) {
                  isCheckboxReadOnly = true
                }
              }
        
              if(fieldData.dataElement.id == "Bo3avY8dlk4") {
                if(values['A9ViHg2dAnU'] == true || values['OCu38UY9V0L'] == true || values['K5RxgT0Jnsh'] == true|| values['iRw6LO2BUja'] == true) {
                  isCheckboxReadOnly = true
                }
              }
        
              //tb symptoms
              if(fieldData.dataElement.id == "U9q0uWwm2vL" || fieldData.dataElement.id == "S6vS0aZO0GI" || fieldData.dataElement.id == "eSM1pTmW9zg" || fieldData.dataElement.id == "UawZcy0jSMf") {
                
                if(values['hnjdcmsbT5H'] == 'true' || values['hnjdcmsbT5H'] == true) { //no symptoms
                  isCheckboxReadOnly = true
                }
              }
        
              if(fieldData.dataElement.id == "hnjdcmsbT5H") {
                if(values['U9q0uWwm2vL'] == true || values['S6vS0aZO0GI'] == true || values['eSM1pTmW9zg'] == true|| values['UawZcy0jSMf'] == true) {
                  isCheckboxReadOnly = true
                }
              }
            return (
                <Field
                    type="checkbox"
                    component={CheckboxFieldFF}
                    name={DataElementGroup.id}
                    // disabled={isFieldDisbaled}
                    disabled={isCheckboxReadOnly ? true : false}
                    initialValue = {isCheckboxReadOnly ? readOnlyCheckboxArr:''}
                    label={getTranslatedLabels(fieldData.dataElement)}
                    value={fieldData.dataElement.id}
                />
            );
        }
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    useEffect(() => {
        if (validationResult != null) {
            setFieldStructure(
                <Grid item xs={12} sm={4} className={validationResult.hideShow == true ? 'customLoc' : 'hide'}>
                    <FieldGroupFF
                        label={getTranslatedLabels(DataElementGroup)}
                        // onClick={(e, v) => onChange(e, v)}
                        name={DataElementGroup.id}
                    >
                        {DataElementGroup.dataElements.map((field) => {
                            return getFieldDetails(field.id, values);
                        })}
                    </FieldGroupFF>
                </Grid>
            )
        }

    }, [validationResult,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )

}
function QrCodeScanner(props) {
    
    let fieldData = props.fieldData
    
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values

    const [fieldStructure, setFieldStructure] = useState(null)
    const [showScannner, setShowScannner] = useState(false)
    const [defaultValue, setDefaultValue] = useState(null)
    
    function qrErrorhandler() {
        setShowScannner(false)
    }

    function handleQRScan(data) {
        if (data) {
            setShowScannner(false)
            setDefaultValue(data)
        }
    }

    function closeQrSacnner() {
        setShowScannner(false)
    }
    function openCordovaQrScanner (){
        
        let that = this;
        window.cordova.plugins.barcodeScanner.scan(
            function (result) {
                handleQRScan(result.text);
                //setShowScannner(false)
                //setDefaultValue(result.text)
            },
            function (error) {
                
            },
            {
                preferFrontCamera: false, // iOS and Android
                showFlipCameraButton: true, // iOS and Android
                showTorchButton: false, // iOS and Android
                torchOn: false, // Android, launch with the torch switched on (if available)
                prompt: 'Place a barcode inside the scan area', // Android
                resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                //formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
                //orientation : "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
                disableAnimations: true, // iOS
                disableSuccessBeep: false // iOS
            }
         );    
    }
    function openQrSacnner () {
        if(window.cordova){
            openCordovaQrScanner()
        }else{
            setShowScannner(true)
        }
    }
    
    useEffect(() => {
        if(showScannner) {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} >
                    <div style={{ display: 'none' }}>
                        <Field
                            name={fieldData.dataElement.id}
                            label={getTranslatedLabels(fieldData.dataElement)}
                            type={fieldData.dataElement.valueType}
                            component={InputFieldFF}
                            key={fieldData.dataElement.id}
                            defaultValue={defaultValue}
                        />
                    </div>
                    <div>
                        <QrReader
                            delay={300}
                            onError={qrErrorhandler}
                            onScan={handleQRScan}
                            style={{ width: '50%', cursor: 'pointer' }}
                        />
                        <span onClick={() =>closeQrSacnner()}><FontAwesomeIcon icon={faTimes} /></span>
                    </div>
                </Grid>
            )
        } else {
            setFieldStructure(
                <Grid item xs={12} sm={4} md={4} >
                    <div style={{ display: 'none' }}>
                        <Field
                            name={fieldData.dataElement.id}
                            label={getTranslatedLabels(fieldData.dataElement)}
                            type={fieldData.dataElement.valueType}
                            component={InputFieldFF}
                            key={fieldData.dataElement.id}
                            defaultValue={defaultValue}
                        />
                    </div>
                <p className="qrIcon" onClick={() => openQrSacnner()}><FontAwesomeIcon className="fa-3x" icon={faQrcode} /></p>
                </Grid>
            )
        }
    }, [showScannner,defaultValue,localStorage.getItem("locale")])


    return (
        <>
            {
                fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}
function ImageFieldConfig(props) {
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let dataElementGroup = props.dataElementGroup

    const [fieldStructure, setFieldStructure] = useState(null)
    const [validationResult, setValidationResult] = useState(null)
    const [defaultValue, setDefaultValue] = useState(null)
    function handleSave() {

    }

    function handleChange(files) {
        
        if(files.length > 0) {
            let data = new FormData();
        data.append('file', files[0]);
        
        axios({
            method: 'post',
            url: 'https://undp.imonitorplus.com/service/api/fileResources',
            data: data,
            headers: {
                //'Content-Type':  'multipart/form-data',
                Authorization: 'Basic SGVhbHRod29ya2VyQHVuZHAuY29tOkhlYWx0aHdvcmtlckAxMjM='
            }
            })
            .then(function (response) {
                //handle success
                
            })
            .catch(function (response) {
                //handle error
            })
        }
        
        
    }

    function fetchValidation() {
        const validationResult = Validator(fieldData.dataElement.id, fieldData, values, programRules, programRulesVariables, dataElementGroup)
        setValidationResult(validationResult)
    }

    useEffect(() => {
        fetchValidation()
    }, [values])

    async function openFileChooser(){
        console.log("openFileChooser")
        const file = await window.chooser.getFile();
        console.log(file);
        setDefaultValue(file)
    }
    useEffect(() => {
        
        if (validationResult != null) {
            if(window.cordova && !navigator.onLine){
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                        <div style={{ display: 'none' }}>
                            <Field
                                name={fieldData.dataElement.id}
                                label={getTranslatedLabels(fieldData.dataElement)}
                                type={fieldData.dataElement.valueType}
                                component={InputFieldFF}
                                key={fieldData.dataElement.id}
                                defaultValue={defaultValue}
                            />
                        </div>
                        <label>{getTranslatedLabels(fieldData.dataElement)}</label>
                        <p className="qrIcon" onClick={() => openFileChooser()}><FontAwesomeIcon className="fa-3x" icon={faFileUpload} /></p>
    
                    </Grid> 
                )
            }else{
                setFieldStructure(
                    <Grid item xs={12} sm={4} md={4} className={validationResult.hideShow == true ? '' : 'hide'}>
                        {/* <DropzoneArea
                            name={fieldData.dataElement.id}
                            onChange={handleChange.bind(this)}
                            filesLimit={1}
                        /> */}

                        <Field
                            name={fieldData.dataElement.id}
                            label={getTranslatedLabels(fieldData.dataElement)}
                            component={FileInputFieldFF}
                            key={fieldData.dataElement.id}
                            required={fieldData.compulsory && validationResult.hideShow == true ? true : false}
                            value={[]}
                            //onChange={handleChange.bind(this)}
                            //validate={composeValidators(required, URLCheck)}
                        />

                    </Grid>
                )
            }
        }

    }, [validationResult,defaultValue,localStorage.getItem("locale")])

    return (
        <>
            {fieldStructure != null ? fieldStructure : <> </>

            }
        </>
    )
}

function CreateField(props) {
    let customfieldobj = props.customfieldobj;
    let customIsDisable = props.customIsDisable;
    let fieldData = props.fieldData
    let programRules = props.programRules
    let programRulesVariables = props.programRulesVariables
    let values = props.values
    let programData = props.programData
    let dataElementGroup = props.dataElementGroup
    let stages = props.stages
    let orgid = props.orgid
    let OUM = OUMapping(values)
    let OUJSON = props.OUJSON
    let stagesData = props.stagesData;
    let artEnrollmentFacilities = [];
    let newServiceVariable = props.newServiceData
    let townshipList = props.townshipList
    let rules = {
        "programRule": props.programRules,
        "programRuleVariable":props.programRulesVariables
     }
    function checkFieldType() {
        let checkUnique = false;
        if(fieldData.dataElement.attributeValues.length > 0 && fieldData.dataElement.attributeValues[0].attribute.displayName == "unique" && fieldData.dataElement.attributeValues[0].value){
            checkUnique = true;
        }
        if(fieldData.dataElement.id == "YmMhbvuwGZ1" || fieldData.dataElement.displayName == customfieldobj.facilityofArtInitiated || fieldData.dataElement.fieldMask == customfieldobj.facilityofArtInitiated){
            let autocompleteData = [];
            if(!localStorage.getItem("artEnrollmentFacilities")){
                apiServices.postAPI('save/org/list', {"uid" : "diBTNzaEMGg"})
                .then(ouResponse => {
                    const fetchOUOptions = ouResponse.data.data
                    const OUOptions = fetchOUOptions;
                    if(OUOptions.length > 0) {
                        OUOptions.map(items => {
                            let obj = {
                                'id': items.uid , 
                                'label': items.name, 
                                'value': items.name//items.uid
                            }
                            artEnrollmentFacilities.push(obj)
                        })
                        artEnrollmentFacilities = _.orderBy(artEnrollmentFacilities, ['label'],['asc'])
                        localStorage.setItem("artEnrollmentFacilities",JSON.stringify(artEnrollmentFacilities));
                    }
                })
            }
        }
        switch (fieldData.dataElement.valueType) {
            case 'TEXT':
                return fieldData.dataElement.unique
                    ?
                    <DefaultValueField
                        fieldData={fieldData}
                        programRules={programRules}
                        programRulesVariables={programRulesVariables}
                        values={values}
                        dataElementGroup={dataElementGroup}
                        stagesData = {stagesData}
                    /> 
                    :
                    checkUnique
                    ?
                    <DefaultStageValueField
                        fieldData={fieldData}
                        programRules={programRules}
                        programRulesVariables={programRulesVariables}
                        values={values}
                        dataElementGroup={dataElementGroup}
                        stagesData = {stagesData}
                    /> 
                    :
                    fieldData.dataElement.fieldMask == "Facility Referral"
                        ?
                        <ReferalConfig
                            fieldData={fieldData}
                            programRules={programRules}
                            programRulesVariables={programRulesVariables}
                            values={values}
                            dataElementGroup={dataElementGroup}
                            programData={programData}
                            stage={stages}
                            stagesData = {stagesData}
                        />
                        :
                        fieldData.renderType && fieldData.renderType['DESKTOP'] && fieldData.renderType['DESKTOP'].type == "QR_CODE" ?
                        <QrCodeScanner
                            fieldData={fieldData}
                            programRules={programRules}
                            programRulesVariables={programRulesVariables}
                            values={values}
                            stagesData = {stagesData}
                        />
                        : <InputFieldConfig
                            fieldData={fieldData}
                            customfieldobj={customfieldobj}
                            programRules={programRules}
                            programRulesVariables={programRulesVariables}
                            values={values}
                            dataElementGroup={dataElementGroup}
                            OUJSON = {OUJSON}
                            programorgid={orgid}
                            stagesData = {stagesData}
                            newServiceData = {newServiceVariable}
                            customIsDisable= {customIsDisable}
                        />

            case 'IMAGE':
            case "FILE_RESOURCE":
                return <ImageFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                />

            case 'DATE':
                return <DateFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    customfieldobj={customfieldobj}
                    dataElementGroup={dataElementGroup}
                    stagesData = {stagesData}
                    newServiceData = {newServiceVariable}
                />

            case 'AGE':
                return <AgeFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                />

            case 'PHONE_NUMBER':
                return <PhoneNumberFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                />

            case 'EMAIL':
                return <EmailFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                />
            case 'BOOLEAN':
                //dataElementGroup
                if (
                    dataElementGroup.filter(
                        (obj) => obj.displayName == fieldData.dataElement.displayName
                    ).length > 0
                ) {
                    const filterDataElementGroup = dataElementGroup.filter(
                        (obj) => obj.displayName == fieldData.dataElement.displayName
                    )[0];

                    return (
                        <MultiSelectConfig
                            fieldData={fieldData}
                            programRules={programRules}
                            programRulesVariables={programRulesVariables}
                            values={values}
                            DataElementGroup={filterDataElementGroup}
                            dataElementGroup={dataElementGroup}
                            programObj={programData}
                            stages={stages}
                        />
                    )


                } else {
                    // const filterDataElementGroup = dataElementGroup.dataElementGroups.filter(obj => obj.displayName == attribute.dataElement.displayName)[0]

                    let ShowFieldFlag = true;
                    dataElementGroup.map((DEG) => {
                        DEG.dataElements.map((DataElements) => {
                            if (DataElements.id == fieldData.dataElement.id) {
                                ShowFieldFlag = false;
                            }
                        });
                    });

                    if (ShowFieldFlag) {
                        return <BooleanFieldConfig
                            fieldData={fieldData}
                            programRules={programRules}
                            programRulesVariables={programRulesVariables}
                            values={values}
                            dataElementGroup={dataElementGroup}
                        />
                    } else {
                        return <> </>;
                    }
                }

            case "TRUE_ONLY":
                if (
                    dataElementGroup.filter(
                        (obj) => obj.displayName == fieldData.dataElement.displayName
                    ).length > 0
                ) {
                    const filterDataElementGroup = dataElementGroup.filter(
                        (obj) => obj.displayName == fieldData.dataElement.displayName
                    )[0];

                    return (
                        <MultiSelectConfig
                            fieldData={fieldData}
                            programRules={programRules}
                            programRulesVariables={programRulesVariables}
                            values={values}
                            DataElementGroup={filterDataElementGroup}
                            programObj={programData}
                            stages={stages}
                            dataElementGroup={dataElementGroup}
                        />
                    )


                } else {
                    // const filterDataElementGroup = dataElementGroup.dataElementGroups.filter(obj => obj.displayName == attribute.dataElement.displayName)[0]

                    let ShowFieldFlag = true;
                    dataElementGroup.map((DEG) => {
                        DEG.dataElements.map((DataElements) => {
                            if (DataElements.id == fieldData.dataElement.id) {
                                ShowFieldFlag = false;
                            }
                        });
                    });

                    if (ShowFieldFlag) {
                        return <BooleanFieldConfig
                            fieldData={fieldData}
                            programRules={programRules}
                            programRulesVariables={programRulesVariables}
                            values={values}
                            dataElementGroup={dataElementGroup}
                        />
                    } else {
                        return <> </>;
                    }
                }
            // case 'TRUE_ONLY': 
            //     return <BooleanFieldConfig
            //         fieldData={fieldData}
            //         programRules={programRules}
            //         programRulesVariables={programRulesVariables}
            //         values={values}  
            //     />
            case 'TIME':
                return <TimeFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                />

            case 'DATETIME':
                return <DateTimeFieldConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                />

            case 'INTEGER':
            case 'INTEGER_POSITIVE':
            case 'INTEGER_NEGATIVE':
            case 'INTEGER_ZERO_OR_POSITIVE':
            case 'NUMBER':
                return <IntegerConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    customfieldobj = {customfieldobj}
                    dataElementGroup={dataElementGroup}
                />
            case 'LONG_TEXT':
                return <TextAreaConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                />

            case 'USERNAME':
                return <UserNameConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                    programorgid={orgid}
                />

            case 'URL':
                return <URLConfig
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    dataElementGroup={dataElementGroup}
                />

            case 'ORGANISATION_UNIT':
                let optionsId = ''
                const childDropDown = JSON.parse(localStorage.getItem('childDropDown'))
                if (childDropDown != null) {
                    const fieldOptionFilter = childDropDown.filter(obj => obj.fieldId == fieldData.dataElement.id)
                    if (fieldOptionFilter.length > 0) {
                        optionsId = fieldOptionFilter[0].value
                    }

                }

                const defaultValue = values[fieldData.dataElement.id]
                let defaultOption = {}
                if (defaultValue != undefined) {
                    const meta = JSON.parse(localStorage.getItem('metaData'))
                    const LocationFilter = programData.organisationUnits.filter(OU => OU.id == values[fieldData.dataElement.id])
                    const locationName = LocationFilter.length > 0 ? LocationFilter[0].displayName : ""

                    defaultOption = {
                        'id': values[fieldData.dataElement.id],
                        'label': locationName,
                        'value': values[fieldData.dataElement.id]
                    }
                    if (OUM[fieldData.dataElement.id] != undefined) {
                        if (OUM[fieldData.dataElement.id].parent != '') {
                            optionsId = values[OUM[fieldData.dataElement.id].parent]
                        }
                    }
                }
                //console.log("orgname ",fieldData.dataElement.displayName)
                return <HandleOUOptions
                    fieldData={fieldData}
                    programRules={programRules}
                    programRulesVariables={programRulesVariables}
                    values={values}
                    customfieldobj={customfieldobj}
                    programData={programData}
                    options={optionsId} 
                    defaultOption={defaultOption}
                    OUJSON = {OUJSON}
                    stagesData = {stagesData}
                    newServiceData = {newServiceVariable}
                    townshipList = {townshipList}
                    //data={fieldData} values={values} rules={rules} options={optionsId} defaultOption={defaultOption}
                />

        }
    }


    return (
        <>
            {checkFieldType()}
        </>

    )
}

export default CreateField
